import { Duration } from 'luxon';
import { OrderPointType } from '../../../dashboard/orders/common/enums/order-point-type';
import { TransitOperator } from '../../enums/transit/transit-operator';
import type { TransitRoute } from '../../interfaces/transit/transit-route';
import { FERRIES } from './ferries';
import { TransitFrequencyInterval } from '../../enums/transit/transit-frequency-interval';

export const FERRY_ROUTES: TransitRoute[] = [
  /* Albania */
  // Durres
  {
    uuid: '72b65a5b-0e54-4610-9221-c6c66639d184',
    type: OrderPointType.FERRY,
    from: FERRIES.durres,
    to: FERRIES.ancona,
    operator: TransitOperator.ARDIA_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 16 }).as('seconds'),
  },
  {
    uuid: '805ab2ba-917e-42ec-9a5b-f570fe0b370f',
    type: OrderPointType.FERRY,
    from: FERRIES.durres,
    to: FERRIES.bari,
    operator: TransitOperator.GRANDI_NAVI_VELOCI,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 10 }).as('seconds'),
  },

  /* Algeria */
  // TODO: Currently unsupported country (outside of Europe)

  /* Balearic Islands */
  // Alcudia
  {
    uuid: 'e2beaf0d-1a92-4f48-9c4e-3262aa460a1c',
    type: OrderPointType.FERRY,
    from: FERRIES.alcudia,
    to: FERRIES.barcelona,
    operator: TransitOperator.TRANSMED_GLE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 7 }).as('seconds'),
  },
  {
    uuid: '13251406-f84c-45e8-9829-54016b07e3b8',
    type: OrderPointType.FERRY,
    from: FERRIES.alcudia,
    to: FERRIES.ciutadella,
    operator: TransitOperator.BALEARIA,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 4 },
    duration: Duration.fromObject({ hours: 1 }).as('seconds'),
  },
  // Ciutadella
  {
    uuid: '0fd0ae0c-fbf4-49f7-8a8e-e35c056a1696',
    type: OrderPointType.FERRY,
    from: FERRIES.ciutadella,
    to: FERRIES.alcudia,
    operator: TransitOperator.BALEARIA,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 4 },
    duration: Duration.fromObject({ hours: 1 }).as('seconds'),
  },
  {
    uuid: '885138ec-e5fd-400b-a2f3-8355c30e683b',
    type: OrderPointType.FERRY,
    from: FERRIES.ciutadella,
    to: FERRIES.barcelona,
    operator: TransitOperator.BALEARIA,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 7 }).as('seconds'),
  },
  // Ibiza
  {
    uuid: '94da8f9b-7bee-4d66-802d-7d9e98760777',
    type: OrderPointType.FERRY,
    from: FERRIES.ibiza,
    to: FERRIES.barcelona,
    operator: TransitOperator.TRANSMED_GLE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  {
    uuid: '6573c913-8647-4c91-a632-380465f513fc',
    type: OrderPointType.FERRY,
    from: FERRIES.ibiza,
    to: FERRIES.denia,
    operator: TransitOperator.BALEARIA,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  {
    uuid: '5dbca009-4e9e-4a2e-867b-6e38a21ce8ec',
    type: OrderPointType.FERRY,
    from: FERRIES.ibiza,
    to: FERRIES.palmaMallorca,
    operator: TransitOperator.BALEARIA,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  {
    uuid: 'b28e449e-4303-4050-b6d9-ddcca5a54c65',
    type: OrderPointType.FERRY,
    from: FERRIES.ibiza,
    to: FERRIES.valencia,
    operator: TransitOperator.TRANSMED_GLE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 6 }).as('seconds'),
  },
  // Mahon
  {
    uuid: 'c94610e7-6215-4e09-97ca-91369beecb70',
    type: OrderPointType.FERRY,
    from: FERRIES.mahon,
    to: FERRIES.barcelona,
    operator: TransitOperator.TRANSMED_GLE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  {
    uuid: 'd7b1870a-0623-4f03-a2d5-8aa0376037df',
    type: OrderPointType.FERRY,
    from: FERRIES.mahon,
    to: FERRIES.palmaMallorca,
    operator: TransitOperator.TRANSMED_GLE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 6 }).as('seconds'),
  },
  {
    uuid: 'bda9f00a-346d-4561-a661-d89914f6b96b',
    type: OrderPointType.FERRY,
    from: FERRIES.mahon,
    to: FERRIES.valencia,
    operator: TransitOperator.TRANSMED_GLE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 15 }).as('seconds'),
  },
  // Palma Mallorca
  {
    uuid: 'd80daf9b-329a-4634-b5dd-ad57a3ff6018',
    type: OrderPointType.FERRY,
    from: FERRIES.palmaMallorca,
    to: FERRIES.barcelona,
    operator: TransitOperator.TRANSMED_GLE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 8 }).as('seconds'),
  },
  {
    uuid: 'dc8769c5-2586-4d23-a3e2-ed2ed6f971fa',
    type: OrderPointType.FERRY,
    from: FERRIES.palmaMallorca,
    to: FERRIES.denia,
    operator: TransitOperator.BALEARIA,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 5 }).as('seconds'),
  },
  {
    uuid: '71f1f151-9563-439c-b26c-90651d15cdf6',
    type: OrderPointType.FERRY,
    from: FERRIES.palmaMallorca,
    to: FERRIES.ibiza,
    operator: TransitOperator.BALEARIA,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  {
    uuid: 'c2131115-da43-4d35-8f20-4a517c3c15fe',
    type: OrderPointType.FERRY,
    from: FERRIES.palmaMallorca,
    to: FERRIES.mahon,
    operator: TransitOperator.TRANSMED_GLE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 6 }).as('seconds'),
  },
  {
    uuid: 'a93ac151-41bd-4f9f-86f9-a85c82e361b8',
    type: OrderPointType.FERRY,
    from: FERRIES.palmaMallorca,
    to: FERRIES.sagunto,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 7 }).as('seconds'),
  },
  {
    uuid: '7fe3ad2c-6aed-403f-841a-6c311c47d9cc',
    type: OrderPointType.FERRY,
    from: FERRIES.palmaMallorca,
    to: FERRIES.valencia,
    operator: TransitOperator.TRANSMED_GLE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 8 }).as('seconds'),
  },

  /* Belgium */
  // Antwerp
  {
    uuid: '4421cb3a-f0c3-48fe-9bfa-0f5bc0d05572',
    type: OrderPointType.FERRY,
    from: FERRIES.antwerp,
    to: FERRIES.gdynia,
    operator: TransitOperator.TRANSFENNICA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 134 }).as('seconds'),
  },
  {
    uuid: '61a46d1a-4b1e-4c86-87ef-ee3e5ca6e04c',
    type: OrderPointType.FERRY,
    from: FERRIES.antwerp,
    to: FERRIES.tilbury,
    operator: TransitOperator.TRANSFENNICA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 21 }).as('seconds'),
  },
  // Ghent
  {
    uuid: '07aaac8c-c8fd-4335-8959-900c075539eb',
    type: OrderPointType.FERRY,
    from: FERRIES.ghent,
    to: FERRIES.brevik,
    operator: TransitOperator.DFDS_SEAWAYS_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 33 }).as('seconds'),
  },
  // Zeebrugge
  {
    uuid: 'e0fc98be-b947-4c22-9eeb-7de6585775f3',
    type: OrderPointType.FERRY,
    from: FERRIES.zeebrugge,
    to: FERRIES.cork,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 27 }).as('seconds'),
  },
  {
    uuid: 'dde386a1-5869-4971-874d-acc0b529ad1e',
    type: OrderPointType.FERRY,
    from: FERRIES.zeebrugge,
    to: FERRIES.frederikstad,
    operator: TransitOperator.DFDS_SEAWAYS_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 17 }).as('seconds'),
  },
  {
    uuid: 'ea157dfc-6b06-4de8-bd27-232b3a5b23f4',
    type: OrderPointType.FERRY,
    from: FERRIES.zeebrugge,
    to: FERRIES.gothenburg,
    operator: TransitOperator.DFDS_SEAWAYS_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 4 },
    duration: Duration.fromObject({ hours: 34 }).as('seconds'),
  },
  {
    uuid: 'be4d6729-0a1b-4f4a-bd0f-b6c756bc6736',
    type: OrderPointType.FERRY,
    from: FERRIES.zeebrugge,
    to: FERRIES.helsinki,
    operator: TransitOperator.FINNLINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 120 }).as('seconds'),
  },
  {
    uuid: 'cb897889-0d19-4668-bad5-62872e71b80e',
    type: OrderPointType.FERRY,
    from: FERRIES.zeebrugge,
    to: FERRIES.hull,
    operator: TransitOperator.PO_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 15 }).as('seconds'),
  },
  {
    uuid: '8a283c7a-b0c6-4aaa-b46b-75e55a5d3ad2',
    type: OrderPointType.FERRY,
    from: FERRIES.zeebrugge,
    to: FERRIES.immingham,
    operator: TransitOperator.DFDS_SEAWAYS_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 18 }).as('seconds'),
  },
  {
    uuid: '1c318463-36f8-4720-b566-bf41ca6a382e',
    type: OrderPointType.FERRY,
    from: FERRIES.zeebrugge,
    to: FERRIES.rosslare,
    operator: TransitOperator.FINNLINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 19 }).as('seconds'),
  },
  {
    uuid: '0f975963-5ee6-4170-9642-051e43dc5b8d',
    type: OrderPointType.FERRY,
    from: FERRIES.zeebrugge,
    to: FERRIES.teesport,
    operator: TransitOperator.PO_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 20 }).as('seconds'),
  },
  {
    uuid: 'c0d8d012-2cf3-48a2-98f0-095b57a03dd7',
    type: OrderPointType.FERRY,
    from: FERRIES.zeebrugge,
    to: FERRIES.tilbury,
    operator: TransitOperator.PO_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 8 }).as('seconds'),
  },

  /* Bulgaria */
  // Burgas
  {
    uuid: '4a32fa6e-8607-49a9-9371-182c53da7022',
    type: OrderPointType.FERRY,
    from: FERRIES.burgas,
    to: FERRIES.batumi,
    operator: TransitOperator.PB_MANAGEMENT,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 72 }).as('seconds'),
  },
  // Varna
  {
    uuid: 'a737d78e-cacd-454c-b31f-4dd8d21ecf12',
    type: OrderPointType.FERRY,
    from: FERRIES.varna,
    to: FERRIES.batumi,
    operator: TransitOperator.UKRFERRY,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 54 }).as('seconds'),
  },

  /* Canary Islands */
  // Arrecife
  {
    uuid: '783a8621-f5d3-47be-b5c6-295b629eb7ba',
    type: OrderPointType.FERRY,
    from: FERRIES.arrecife,
    to: FERRIES.cadiz,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 31 }).as('seconds'),
  },
  {
    uuid: '79598c39-c132-4f7e-a0b3-667232725ad4',
    type: OrderPointType.FERRY,
    from: FERRIES.arrecife,
    to: FERRIES.huelva,
    operator: TransitOperator.BALEARIA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 59 }).as('seconds'),
  },
  {
    uuid: 'a3388f76-798b-4f05-9fbe-a292962a2bb8',
    type: OrderPointType.FERRY,
    from: FERRIES.arrecife,
    to: FERRIES.lasPalmasGranCanaria,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 6 }).as('seconds'),
  },
  {
    uuid: '63691601-0f47-4b51-898e-ec6bf13ae120',
    type: OrderPointType.FERRY,
    from: FERRIES.arrecife,
    to: FERRIES.santaCruzDeTenerife,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 11 }).as('seconds'),
  },
  // Las Palmas Gran Canaria
  {
    uuid: 'c5a55a3c-f035-400b-aebd-db1c3f1fe7e2',
    type: OrderPointType.FERRY,
    from: FERRIES.lasPalmasGranCanaria,
    to: FERRIES.arrecife,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 8 }).as('seconds'),
  },
  {
    uuid: '16863ac9-04ac-44b4-9ef1-8a6aa2e744eb',
    type: OrderPointType.FERRY,
    from: FERRIES.lasPalmasGranCanaria,
    to: FERRIES.cadiz,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 40 }).as('seconds'),
  },
  {
    uuid: '7df3fba8-58c1-4e22-989f-1963fc1885a7',
    type: OrderPointType.FERRY,
    from: FERRIES.lasPalmasGranCanaria,
    to: FERRIES.huelva,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 41 }).as('seconds'),
  },
  {
    uuid: 'd97efb2d-e58a-4dba-9fce-90b50c09683e',
    type: OrderPointType.FERRY,
    from: FERRIES.lasPalmasGranCanaria,
    to: FERRIES.puertoRosario,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 6 }).as('seconds'),
  },
  {
    uuid: '2e18f16e-971e-4bcf-bac8-45f31bb36019',
    type: OrderPointType.FERRY,
    from: FERRIES.lasPalmasGranCanaria,
    to: FERRIES.santaCruzDeLaPalma,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  {
    uuid: '03bf7baa-b734-4f4c-8322-d4e52b27f35c',
    type: OrderPointType.FERRY,
    from: FERRIES.lasPalmasGranCanaria,
    to: FERRIES.santaCruzDeTenerife,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 6 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  // Puerto Rosario
  {
    uuid: 'd5eae223-ccc9-4679-8bb6-1ed50f4c7492',
    type: OrderPointType.FERRY,
    from: FERRIES.puertoRosario,
    to: FERRIES.arrecife,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 3 }).as('seconds'),
  },
  {
    uuid: 'f07715e0-7352-4d36-be97-ab62ccaddb7f',
    type: OrderPointType.FERRY,
    from: FERRIES.puertoRosario,
    to: FERRIES.cadiz,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 37 }).as('seconds'),
  },
  {
    uuid: 'c956a37a-393f-4be0-ae41-5a3bc144921d',
    type: OrderPointType.FERRY,
    from: FERRIES.puertoRosario,
    to: FERRIES.lasPalmasGranCanaria,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 7 }).as('seconds'),
  },
  {
    uuid: '2ecfdf18-809e-417a-8d4b-3130b3a87579',
    type: OrderPointType.FERRY,
    from: FERRIES.puertoRosario,
    to: FERRIES.santaCruzDeLaPalma,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 26 }).as('seconds'),
  },
  {
    uuid: '95e1f7b5-ad53-4a10-af4d-7d3f80b36b1d',
    type: OrderPointType.FERRY,
    from: FERRIES.puertoRosario,
    to: FERRIES.santaCruzDeTenerife,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 11 }).as('seconds'),
  },
  // Santa Cruz de La Palma
  {
    uuid: '33720748-25af-4dcf-b752-a4ec61043c1d',
    type: OrderPointType.FERRY,
    from: FERRIES.santaCruzDeLaPalma,
    to: FERRIES.arrecife,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 30 }).as('seconds'),
  },
  {
    uuid: '26b15077-f367-454e-b612-6235c47d4cac',
    type: OrderPointType.FERRY,
    from: FERRIES.santaCruzDeLaPalma,
    to: FERRIES.cadiz,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 64 }).as('seconds'),
  },
  {
    uuid: '21b1c12f-0ae2-4f9f-b17a-caf8a959fdbb',
    type: OrderPointType.FERRY,
    from: FERRIES.santaCruzDeLaPalma,
    to: FERRIES.lasPalmasGranCanaria,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 7 },
    duration: Duration.fromObject({ hours: 10 }).as('seconds'),
  },
  {
    uuid: 'c7846747-07b9-4d25-be0a-987d675aad17',
    type: OrderPointType.FERRY,
    from: FERRIES.santaCruzDeLaPalma,
    to: FERRIES.puertoRosario,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 26 }).as('seconds'),
  },
  {
    uuid: '99b2bfe1-fd35-46f7-9a6d-25801399303e',
    type: OrderPointType.FERRY,
    from: FERRIES.santaCruzDeLaPalma,
    to: FERRIES.santaCruzDeTenerife,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 6 }).as('seconds'),
  },
  // Santa Cruz de Tenerife
  {
    uuid: '261ff2a2-b817-450c-8885-efac0527aa95',
    type: OrderPointType.FERRY,
    from: FERRIES.santaCruzDeTenerife,
    to: FERRIES.arrecife,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 11 },
    duration: Duration.fromObject({ hours: 14 }).as('seconds'),
  },
  {
    uuid: '0c5baffa-9439-4f53-9349-a8cbf5c68a69',
    type: OrderPointType.FERRY,
    from: FERRIES.santaCruzDeTenerife,
    to: FERRIES.cadiz,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 55 }).as('seconds'),
  },
  {
    uuid: '25c54560-f5cd-43f3-8477-efddaee3f5fa',
    type: OrderPointType.FERRY,
    from: FERRIES.santaCruzDeTenerife,
    to: FERRIES.huelva,
    operator: TransitOperator.BALEARIA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 36 }).as('seconds'),
  },
  {
    uuid: 'a52608ab-1599-461c-a39e-ac303b883a07',
    type: OrderPointType.FERRY,
    from: FERRIES.santaCruzDeTenerife,
    to: FERRIES.lasPalmasGranCanaria,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 7 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  {
    uuid: '544bbff5-fc2b-42d9-923e-63c70aa54ab2',
    type: OrderPointType.FERRY,
    from: FERRIES.santaCruzDeTenerife,
    to: FERRIES.puertoRosario,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 10 },
    duration: Duration.fromObject({ hours: 13 }).as('seconds'),
  },
  {
    uuid: 'f755ceb5-e32c-4a86-9094-caa2d7276b00',
    type: OrderPointType.FERRY,
    from: FERRIES.santaCruzDeTenerife,
    to: FERRIES.santaCruzDeLaPalma,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 7 }).as('seconds'),
  },

  /* Channel Islands */
  // Guernsey
  {
    uuid: '328b4f3c-9992-4df2-8d79-d199d4b59311',
    type: OrderPointType.FERRY,
    from: FERRIES.guernsey,
    to: FERRIES.jersey,
    operator: TransitOperator.CONDOR_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 1 }).as('seconds'),
  },
  {
    uuid: 'f7dac74b-427f-4835-8436-7695fb2cde3f',
    type: OrderPointType.FERRY,
    from: FERRIES.guernsey,
    to: FERRIES.poole,
    operator: TransitOperator.CONDOR_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 4 },
    duration: Duration.fromObject({ hours: 3 }).as('seconds'),
  },
  {
    uuid: '3480cf5b-43b6-4354-9161-711ff2524486',
    type: OrderPointType.FERRY,
    from: FERRIES.guernsey,
    to: FERRIES.portsmouth,
    operator: TransitOperator.CONDOR_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 8 }).as('seconds'),
  },
  {
    uuid: '0148c985-d478-41dd-9f24-3711e6ff8c3b',
    type: OrderPointType.FERRY,
    from: FERRIES.guernsey,
    to: FERRIES.stMalo,
    operator: TransitOperator.CONDOR_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 5 }).as('seconds'),
  },
  // Jersey
  {
    uuid: '4a09b9b8-db13-4932-9f63-af0b536d46d8',
    type: OrderPointType.FERRY,
    from: FERRIES.jersey,
    to: FERRIES.guernsey,
    operator: TransitOperator.CONDOR_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 1 }).as('seconds'),
  },
  {
    uuid: 'd35a0df2-fa67-424e-9000-ee0420a36302',
    type: OrderPointType.FERRY,
    from: FERRIES.jersey,
    to: FERRIES.portsmouth,
    operator: TransitOperator.DFDS_JERSEY,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  {
    uuid: '7aa00560-0880-425b-9ab0-b46f00e36cb7',
    type: OrderPointType.FERRY,
    from: FERRIES.jersey,
    to: FERRIES.stMalo,
    operator: TransitOperator.DFDS_JERSEY,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 8 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },

  /* Corsica */
  // Ajaccio
  {
    uuid: '7c707ceb-754a-46e4-8ecd-56ffe7f303be',
    type: OrderPointType.FERRY,
    from: FERRIES.ajaccio,
    to: FERRIES.marseille,
    operator: TransitOperator.CORSICA_LINEA,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 13 }).as('seconds'),
  },
  {
    uuid: '09138ddc-c68a-4ecb-81be-f444b53ea6b0',
    type: OrderPointType.FERRY,
    from: FERRIES.ajaccio,
    to: FERRIES.portoTorres,
    operator: TransitOperator.CORSICA_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 11 }).as('seconds'),
  },
  {
    uuid: 'a9d97974-3c03-41fe-a1e7-2deb8bf1ddeb',
    type: OrderPointType.FERRY,
    from: FERRIES.ajaccio,
    to: FERRIES.toulon,
    operator: TransitOperator.CORSICA_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 10 },
    duration: Duration.fromObject({ hours: 10 }).as('seconds'),
  },
  // Bastia
  {
    uuid: 'eb007b44-eccd-4f40-bdc4-71198ca5e8a6',
    type: OrderPointType.FERRY,
    from: FERRIES.bastia,
    to: FERRIES.livorno,
    operator: TransitOperator.CORSICA_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 5 }).as('seconds'),
  },
  {
    uuid: '8dd51587-8120-4535-a066-f0491dd47ecd',
    type: OrderPointType.FERRY,
    from: FERRIES.bastia,
    to: FERRIES.marseille,
    operator: TransitOperator.CORSICA_LINEA,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 13 }).as('seconds'),
  },
  {
    uuid: 'ad879579-0edd-4048-94fc-522edc09c1a3',
    type: OrderPointType.FERRY,
    from: FERRIES.bastia,
    to: FERRIES.piombino,
    operator: TransitOperator.CORSICA_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 3 }).as('seconds'),
  },
  {
    uuid: 'cae4b53a-6e52-4bc9-892d-862f53f77ee0',
    type: OrderPointType.FERRY,
    from: FERRIES.bastia,
    to: FERRIES.toulon,
    operator: TransitOperator.CORSICA_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 4 },
    duration: Duration.fromObject({ hours: 12 }).as('seconds'),
  },
  // Ile Rousse
  {
    uuid: 'ebce189c-537f-4096-b2b7-cde58a0b02b3',
    type: OrderPointType.FERRY,
    from: FERRIES.ileRousse,
    to: FERRIES.marseille,
    operator: TransitOperator.CORSICA_LINEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 14 }).as('seconds'),
  },
  // Porto Vecchio
  {
    uuid: 'eacc3611-0819-43fc-a987-6e2b84c55fb7',
    type: OrderPointType.FERRY,
    from: FERRIES.portoVecchio,
    to: FERRIES.marseille,
    operator: TransitOperator.LA_MERIDIONALE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 14 }).as('seconds'),
  },

  /* Cyprus */
  // Limassol
  {
    uuid: 'ae6f09c7-00cd-4f0e-9892-b52d0595b2fb',
    type: OrderPointType.FERRY,
    from: FERRIES.limassol,
    to: FERRIES.lavrio,
    operator: TransitOperator.SALAMIS_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 39 }).as('seconds'),
  },
  {
    uuid: 'd2b1ef55-2288-4771-a7a4-e8d332084c4a',
    type: OrderPointType.FERRY,
    from: FERRIES.limassol,
    to: FERRIES.thessaloniki,
    operator: TransitOperator.SALAMIS_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 44 }).as('seconds'),
  },

  /* Denmark */
  // Copenhagen
  {
    uuid: '42af2360-10b6-4e35-8eac-cf4e2add78a7',
    type: OrderPointType.FERRY,
    from: FERRIES.copenhagen,
    to: FERRIES.oslo,
    operator: TransitOperator.DFDS_SEAWAYS_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 18 }).as('seconds'),
  },
  {
    uuid: '29031edf-5bed-4733-a48b-73493409225c',
    type: OrderPointType.FERRY,
    from: FERRIES.copenhagen,
    to: FERRIES.swinoujscie,
    operator: TransitOperator.POLFERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 7 }).as('seconds'),
  },
  // Esbjerg
  {
    uuid: '813e536a-273b-4ddf-a361-38e0a82908a9',
    type: OrderPointType.FERRY,
    from: FERRIES.esbjerg,
    to: FERRIES.immingham,
    operator: TransitOperator.DFDS_SEAWAYS_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 20 }).as('seconds'),
  },
  // Fredericia
  {
    uuid: '1410c09c-66ad-4c67-9d79-d3309d7f2234',
    type: OrderPointType.FERRY,
    from: FERRIES.fredericia,
    to: FERRIES.klaipeda,
    operator: TransitOperator.DFDS_SEAWAYS_BALTIC_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 30 }).as('seconds'),
  },
  // Frederikshavn
  {
    uuid: 'c89e57af-5684-44e1-80b3-d7b3510bcc81',
    type: OrderPointType.FERRY,
    from: FERRIES.frederikshavn,
    to: FERRIES.gothenburg,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 4 },
    duration: Duration.fromObject({ hours: 4 }).as('seconds'),
  },
  // Gedser
  {
    uuid: '08301045-21b5-4afb-9333-d6285eb41298',
    type: OrderPointType.FERRY,
    from: FERRIES.gedser,
    to: FERRIES.rostock,
    operator: TransitOperator.SCANDLINES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 10 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  // Grenaa
  {
    uuid: 'a6dea18d-5990-4246-8990-0733b6f85c69',
    type: OrderPointType.FERRY,
    from: FERRIES.grenaa,
    to: FERRIES.halmstad,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 10 },
    duration: Duration.fromObject({ hours: 5 }).as('seconds'),
  },
  // Havneby
  {
    uuid: '780214f0-229d-4e10-af8f-0e99b1d39a85',
    type: OrderPointType.FERRY,
    from: FERRIES.havneby,
    to: FERRIES.list,
    operator: TransitOperator.SYLT_FERRY,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 14 },
    duration: Duration.fromObject({ hours: 1 }).as('seconds'),
  },
  // Helsingor
  {
    uuid: 'bcf2e1cb-c94f-4958-93c0-d9690cf07ee7',
    type: OrderPointType.FERRY,
    from: FERRIES.helsingor,
    to: FERRIES.helsingborg,
    operator: TransitOperator.SCANDLINES,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 20 }).as('seconds'),
  },
  // Hirtshals
  {
    uuid: 'b4a1a3f7-1656-4a74-8231-bee24d0f416c',
    type: OrderPointType.FERRY,
    from: FERRIES.hirtshals,
    to: FERRIES.kristiansand,
    operator: TransitOperator.FJORD_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 4 }).as('seconds'),
  },
  {
    uuid: '9fb3277c-4b98-4cf9-b8e3-347ef4c19916',
    type: OrderPointType.FERRY,
    from: FERRIES.hirtshals,
    to: FERRIES.larvik,
    operator: TransitOperator.COLOR_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 4 }).as('seconds'),
  },
  {
    uuid: '47d8cad3-ceed-41cb-a7dc-7975f371e3f8',
    type: OrderPointType.FERRY,
    from: FERRIES.hirtshals,
    to: FERRIES.seydisfjordur,
    operator: TransitOperator.SMYRIL_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 67 }).as('seconds'),
  },
  {
    uuid: 'b454ab54-79e2-48e2-8991-c78ea22ed9ee',
    type: OrderPointType.FERRY,
    from: FERRIES.hirtshals,
    to: FERRIES.torshavn,
    operator: TransitOperator.SMYRIL_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 42 }).as('seconds'),
  },
  // Koge
  {
    uuid: '30341d06-4038-4409-8d5b-580b86498f80',
    type: OrderPointType.FERRY,
    from: FERRIES.koge,
    to: FERRIES.klaipeda,
    operator: TransitOperator.DFDS_SEAWAYS_BALTIC_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 39 }).as('seconds'),
  },
  {
    uuid: 'e682b7e4-326c-445c-abf6-767c01f9f0dd',
    type: OrderPointType.FERRY,
    from: FERRIES.koge,
    to: FERRIES.ronne,
    operator: TransitOperator.BORNHOLMSLINJEN,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 6 }).as('seconds'),
  },
  // Rodby
  {
    uuid: '6750dcaa-2a13-4459-865b-08979430008d',
    type: OrderPointType.FERRY,
    from: FERRIES.rodby,
    to: FERRIES.puttgarden,
    operator: TransitOperator.SCANDLINES,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 45 }).as('seconds'),
  },
  // Rønne
  {
    uuid: 'f542666e-58c6-4ba2-bdb2-1d296ab03543',
    type: OrderPointType.FERRY,
    from: FERRIES.ronne,
    to: FERRIES.koge,
    operator: TransitOperator.BORNHOLMSLINJEN,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 6 }).as('seconds'),
  },
  {
    uuid: '82095c6f-fbfb-4deb-8892-8929f1045326',
    type: OrderPointType.FERRY,
    from: FERRIES.ronne,
    to: FERRIES.ystad,
    operator: TransitOperator.BORNHOLMSLINJEN,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 4 },
    duration: Duration.fromObject({ hours: 1 }).as('seconds'),
  },
  // Tórshavn
  {
    uuid: '79cf0349-60f9-4481-b543-13b7b60012d5',
    type: OrderPointType.FERRY,
    from: FERRIES.torshavn,
    to: FERRIES.hirtshals,
    operator: TransitOperator.SMYRIL_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 38 }).as('seconds'),
  },

  /* England */
  // Dover
  {
    uuid: '934d4c46-6ace-4eda-9a4f-620bd581544e',
    type: OrderPointType.FERRY,
    from: FERRIES.dover,
    to: FERRIES.calais,
    operator: TransitOperator.IRISH_FERRIES,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  {
    uuid: '1365aa46-86b1-4ba7-8a7d-8407a0bfe487',
    type: OrderPointType.FERRY,
    from: FERRIES.dover,
    to: FERRIES.dunkirk,
    operator: TransitOperator.DFDS_SEAWAYS_DOVER,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  // Felixstowe
  {
    uuid: '496617ef-a3a7-4b41-b7f2-03cee81dd70a',
    type: OrderPointType.FERRY,
    from: FERRIES.felixstowe,
    to: FERRIES.rotterdamVlaardingen,
    operator: TransitOperator.DFDS_SEAWAYS_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 3 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  // Folkestone
  {
    uuid: '7c17c906-dbf2-4704-b1e9-76a94bde1c1b',
    type: OrderPointType.FERRY,
    from: FERRIES.folkestone,
    to: FERRIES.calais,
    operator: TransitOperator.LESHUTTLE_EUROTUNNEL_FREIGHT,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 35 }).as('seconds'),
  },
  {
    uuid: '333d8f57-7ff0-47cf-80a6-efe6228a1d99',
    type: OrderPointType.FERRY,
    from: FERRIES.folkestone,
    to: FERRIES.calais,
    operator: TransitOperator.LESHUTTLE_EUROTUNNEL_FREIGHT_VP_FLEXI,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 35 }).as('seconds'),
  },
  {
    uuid: '1d98db37-c553-427e-93fa-31523164df45',
    type: OrderPointType.FERRY,
    from: FERRIES.folkestone,
    to: FERRIES.calais,
    operator: TransitOperator.LESHUTTLE_EUROTUNNEL_FREIGHT_VANS_ON_PASSENGER_VP,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 30 }).as('seconds'),
  },
  // Harwich
  {
    uuid: '07f9368c-672c-4688-bf10-1e312ce6af39',
    type: OrderPointType.FERRY,
    from: FERRIES.harwich,
    to: FERRIES.hookOfHolland,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 7 }).as('seconds'),
  },
  {
    uuid: '4e81b1af-578b-4005-ae68-d0f4216288de',
    type: OrderPointType.FERRY,
    from: FERRIES.harwich,
    to: FERRIES.rotterdamEuropoortMerseyweg,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 10 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  // Heysham
  {
    uuid: '9bdabfe7-c148-4e58-8317-da1ee629c472',
    type: OrderPointType.FERRY,
    from: FERRIES.heysham,
    to: FERRIES.belfast,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  {
    uuid: 'b1ade1ae-aebf-4c3e-a063-90b9fbf5ac46',
    type: OrderPointType.FERRY,
    from: FERRIES.heysham,
    to: FERRIES.douglas,
    operator: TransitOperator.ISLE_OF_MAN_STEAM_PACKET,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 4 }).as('seconds'),
  },
  {
    uuid: '5c10a2cb-46e4-4fdf-9376-d2f4b6809600',
    type: OrderPointType.FERRY,
    from: FERRIES.heysham,
    to: FERRIES.dublin,
    operator: TransitOperator.CLDN_RORO_SEATRUCK_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 8 }).as('seconds'),
  },
  {
    uuid: 'ac7d5e9e-5220-4244-817b-72e8b95dcc4d',
    type: OrderPointType.FERRY,
    from: FERRIES.heysham,
    to: FERRIES.warrenpoint,
    operator: TransitOperator.CLDN_RORO_SEATRUCK_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 10 }).as('seconds'),
  },
  // Hull
  {
    uuid: '33bd4597-81c1-4675-9028-2ca39118735f',
    type: OrderPointType.FERRY,
    from: FERRIES.hull,
    to: FERRIES.rotterdamEuropoortMerseyweg,
    operator: TransitOperator.PO_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 12 }).as('seconds'),
  },
  {
    uuid: '18897ae4-3751-4296-b473-ea42c6c0db6a',
    type: OrderPointType.FERRY,
    from: FERRIES.hull,
    to: FERRIES.zeebrugge,
    operator: TransitOperator.PO_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 4 },
    duration: Duration.fromObject({ hours: 16 }).as('seconds'),
  },
  // Immingham
  {
    uuid: '5d7d0acc-410b-4270-baa6-fb0d1a29fd34',
    type: OrderPointType.FERRY,
    from: FERRIES.immingham,
    to: FERRIES.brevik,
    operator: TransitOperator.DFDS_SEAWAYS_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 36 }).as('seconds'),
  },
  {
    uuid: '0e6281d1-16f7-4660-9d59-5dc783a97452',
    type: OrderPointType.FERRY,
    from: FERRIES.immingham,
    to: FERRIES.cuxhaven,
    operator: TransitOperator.DFDS_SEAWAYS_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 24 }).as('seconds'),
  },
  {
    uuid: '88c8c04b-1a4a-40dd-8dda-b15b2561ff50',
    type: OrderPointType.FERRY,
    from: FERRIES.immingham,
    to: FERRIES.esbjerg,
    operator: TransitOperator.DFDS_SEAWAYS_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 20 }).as('seconds'),
  },
  {
    uuid: '6c572386-ed0f-4c75-9a69-c842d5b8824d',
    type: OrderPointType.FERRY,
    from: FERRIES.immingham,
    to: FERRIES.gothenburg,
    operator: TransitOperator.DFDS_SEAWAYS_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 35 }).as('seconds'),
  },
  {
    uuid: '5f6e456f-09b9-4f75-b6da-878c55b50c00',
    type: OrderPointType.FERRY,
    from: FERRIES.immingham,
    to: FERRIES.haugesund,
    operator: TransitOperator.SEA_CARGO,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 36 }).as('seconds'),
  },
  {
    uuid: '2243f81b-9495-4c20-96f3-a06c234088c6',
    type: OrderPointType.FERRY,
    from: FERRIES.immingham,
    to: FERRIES.rotterdamEuropoortMerseyweg,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 14 }).as('seconds'),
  },
  {
    uuid: '10154348-1b5e-4de2-822b-02ffcccb3212',
    type: OrderPointType.FERRY,
    from: FERRIES.immingham,
    to: FERRIES.rotterdamVlaardingen,
    operator: TransitOperator.DFDS_SEAWAYS_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 7 },
    duration: Duration.fromObject({ hours: 13 }).as('seconds'),
  },
  {
    uuid: '3201c85a-2c55-4080-af85-685a37905a10',
    type: OrderPointType.FERRY,
    from: FERRIES.immingham,
    to: FERRIES.tananger,
    operator: TransitOperator.SEA_CARGO,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 50 }).as('seconds'),
  },
  // Killingholme
  {
    uuid: '2751f154-f5fa-4148-8747-24519ec96190',
    type: OrderPointType.FERRY,
    from: FERRIES.killingholme,
    to: FERRIES.hookOfHolland,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 12 }).as('seconds'),
  },
  // Liverpool
  {
    uuid: '0928499e-4f0b-44b6-9257-adba838520c6',
    type: OrderPointType.FERRY,
    from: FERRIES.liverpool,
    to: FERRIES.dublin,
    operator: TransitOperator.CLDN_RORO_SEATRUCK_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 3 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  // Liverpool Birkenhead
  {
    uuid: '05587cd0-33ef-4c77-8b9e-f4c809515e2e',
    type: OrderPointType.FERRY,
    from: FERRIES.liverpoolBirkenhead,
    to: FERRIES.belfast,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 3 },
    duration: Duration.fromObject({ hours: 8 }).as('seconds'),
  },
  {
    uuid: 'b96d3ee4-203a-4948-9667-4303f08f4b28',
    type: OrderPointType.FERRY,
    from: FERRIES.liverpoolBirkenhead,
    to: FERRIES.dublin,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 8 }).as('seconds'),
  },
  // Lymington
  {
    uuid: 'ffa3a52c-cf33-484a-91e3-9ed75c35474f',
    type: OrderPointType.FERRY,
    from: FERRIES.lymington,
    to: FERRIES.yarmouth,
    operator: TransitOperator.WIGHTLINK_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 16 },
    duration: Duration.fromObject({ minutes: 40 }).as('seconds'),
  },
  // Newcastle
  {
    uuid: '959660ee-dd67-44d0-86b5-a9f15cf30015',
    type: OrderPointType.FERRY,
    from: FERRIES.newcastle,
    to: FERRIES.ijmuiden,
    operator: TransitOperator.DFDS_SEAWAYS_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 16 }).as('seconds'),
  },
  // Newhaven
  {
    uuid: 'e74921e8-fd6c-4b55-8a04-f013ea4ed383',
    type: OrderPointType.FERRY,
    from: FERRIES.newhaven,
    to: FERRIES.dieppe,
    operator: TransitOperator.DFDS_LD_LINES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 4 }).as('seconds'),
  },
  // Plymouth
  {
    uuid: '2a6a370f-0bff-42cc-b74c-6f581b628cec',
    type: OrderPointType.FERRY,
    from: FERRIES.plymouth,
    to: FERRIES.roscoff,
    operator: TransitOperator.BRITTANY_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 4 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  {
    uuid: '314a4653-97d3-4f11-9bf1-0b56e8a1018f',
    type: OrderPointType.FERRY,
    from: FERRIES.plymouth,
    to: FERRIES.santander,
    operator: TransitOperator.BRITTANY_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 20 }).as('seconds'),
  },
  // Poole
  {
    uuid: '9f354496-77e4-4af1-ac7d-79e86275830b',
    type: OrderPointType.FERRY,
    from: FERRIES.poole,
    to: FERRIES.cherbourg,
    operator: TransitOperator.BRITTANY_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 5 }).as('seconds'),
  },
  {
    uuid: '59472647-0b55-4197-8dcd-9cced1fed2a2',
    type: OrderPointType.FERRY,
    from: FERRIES.poole,
    to: FERRIES.guernsey,
    operator: TransitOperator.CONDOR_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 4 },
    duration: Duration.fromObject({ hours: 3 }).as('seconds'),
  },
  // Portsmouth
  {
    uuid: '0a597178-1bed-4db9-ab7c-3032aa1489dd',
    type: OrderPointType.FERRY,
    from: FERRIES.portsmouth,
    to: FERRIES.bilbao,
    operator: TransitOperator.BRITTANY_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 35 }).as('seconds'),
  },
  {
    uuid: 'bdd7a90c-fbe0-490d-abb0-f3218b53f2eb',
    type: OrderPointType.FERRY,
    from: FERRIES.portsmouth,
    to: FERRIES.caen,
    operator: TransitOperator.BRITTANY_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 3 },
    duration: Duration.fromObject({ hours: 6 }).as('seconds'),
  },
  {
    uuid: '4afdaadb-de00-418e-bafa-a292567e6f25',
    type: OrderPointType.FERRY,
    from: FERRIES.portsmouth,
    to: FERRIES.fishbourne,
    operator: TransitOperator.WIGHTLINK_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 27 },
    duration: Duration.fromObject({ minutes: 45 }).as('seconds'),
  },
  {
    uuid: '8c909160-6806-4773-ba7f-ebb9c7ef085e',
    type: OrderPointType.FERRY,
    from: FERRIES.portsmouth,
    to: FERRIES.guernsey,
    operator: TransitOperator.CONDOR_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 10 }).as('seconds'),
  },
  {
    uuid: '2c126aec-a0d1-4692-9afc-6e242fdc104d',
    type: OrderPointType.FERRY,
    from: FERRIES.portsmouth,
    to: FERRIES.jersey,
    operator: TransitOperator.DFDS_JERSEY,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 7 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  {
    uuid: '629fb3e0-7971-42ef-b48d-bdd90e5629f2',
    type: OrderPointType.FERRY,
    from: FERRIES.portsmouth,
    to: FERRIES.leHavre,
    operator: TransitOperator.BRITTANY_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 4 },
    duration: Duration.fromObject({ hours: 6 }).as('seconds'),
  },
  {
    uuid: 'c33d64e0-eccc-4aa7-b205-d795122e94d5',
    type: OrderPointType.FERRY,
    from: FERRIES.portsmouth,
    to: FERRIES.santander,
    operator: TransitOperator.BRITTANY_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 33 }).as('seconds'),
  },
  {
    uuid: 'a00b8fd3-7332-4d9e-8f53-2f016d5f2eec',
    type: OrderPointType.FERRY,
    from: FERRIES.portsmouth,
    to: FERRIES.stMalo,
    operator: TransitOperator.BRITTANY_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 11 }).as('seconds'),
  },
  // Sheerness
  {
    uuid: '30fcf614-70ae-4a28-9b47-f78b2c67af67',
    type: OrderPointType.FERRY,
    from: FERRIES.sheerness,
    to: FERRIES.antwerp,
    operator: TransitOperator.FINNLINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 15 }).as('seconds'),
  },
  {
    uuid: 'ca95ca42-8efb-421d-8a37-ce92702b3b40',
    type: OrderPointType.FERRY,
    from: FERRIES.sheerness,
    to: FERRIES.bilbao,
    operator: TransitOperator.FINNLINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 96 }).as('seconds'),
  },
  {
    uuid: '1356ab65-eaea-44e4-8f8e-38b44edbe544',
    type: OrderPointType.FERRY,
    from: FERRIES.sheerness,
    to: FERRIES.zeebrugge,
    operator: TransitOperator.FINNLINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  // Southampton
  {
    uuid: '997e354e-4495-4a6f-834e-1df5f3d29330',
    type: OrderPointType.FERRY,
    from: FERRIES.southampton,
    to: FERRIES.eastCowes,
    operator: TransitOperator.RED_FUNNEL_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 25 },
    duration: Duration.fromObject({ hours: 1 }).as('seconds'),
  },
  // Teesport
  {
    uuid: '9b940359-7fd1-44c1-8432-e25f5cba4c7a',
    type: OrderPointType.FERRY,
    from: FERRIES.teesport,
    to: FERRIES.zeebrugge,
    operator: TransitOperator.PO_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 20 }).as('seconds'),
  },
  // Tilbury
  {
    uuid: '9d81cbd9-0a56-4811-9100-f92831d8cbec',
    type: OrderPointType.FERRY,
    from: FERRIES.tilbury,
    to: FERRIES.antwerp,
    operator: TransitOperator.TRANSFENNICA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 22 }).as('seconds'),
  },
  {
    uuid: '2f05096b-6165-4a3c-b027-4187016693d7',
    type: OrderPointType.FERRY,
    from: FERRIES.tilbury,
    to: FERRIES.rotterdamEuropoortMerseyweg,
    operator: TransitOperator.PO_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 12 }).as('seconds'),
  },
  {
    uuid: 'cad981ba-fb02-44a4-a9cb-681db3ba7519',
    type: OrderPointType.FERRY,
    from: FERRIES.tilbury,
    to: FERRIES.zeebrugge,
    operator: TransitOperator.PO_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 8 }).as('seconds'),
  },

  /* Estonia */
  // Muuga
  {
    uuid: 'dd411a9f-5d9b-4b00-96f7-d7e73c69e8a1',
    type: OrderPointType.FERRY,
    from: FERRIES.muuga,
    to: FERRIES.helsinkiVuosaari,
    operator: TransitOperator.ECKERO_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 16 },
    duration: Duration.fromObject({ hours: 3 }).as('seconds'),
  },
  // Tallinn
  {
    uuid: 'ce7f4d5b-7469-4c40-bdfa-6bb14ebbbe86',
    type: OrderPointType.FERRY,
    from: FERRIES.tallinn,
    to: FERRIES.helsinki,
    operator: TransitOperator.ECKERO_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 3 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  {
    uuid: 'a2592d04-b797-495f-a111-04c9ef981f8e',
    type: OrderPointType.FERRY,
    from: FERRIES.tallinn,
    to: FERRIES.mariehamn,
    operator: TransitOperator.TALLINK_SILJA_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 11 }).as('seconds'),
  },

  /* Finland */
  // Hanko
  {
    uuid: 'c5d19ca4-7656-4f84-a808-c5015b3f51e4',
    type: OrderPointType.FERRY,
    from: FERRIES.hanko,
    to: FERRIES.gdynia,
    operator: TransitOperator.FINNLINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 20 }).as('seconds'),
  },
  {
    uuid: 'f4b76eb0-a91d-4988-b261-170a9e039617',
    type: OrderPointType.FERRY,
    from: FERRIES.hanko,
    to: FERRIES.rostock,
    operator: TransitOperator.TRANSFENNICA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 43 }).as('seconds'),
  },
  // Helsinki
  {
    uuid: 'cd76b346-f0a0-4e9a-ace4-40b546e03394',
    type: OrderPointType.FERRY,
    from: FERRIES.helsinki,
    to: FERRIES.mariehamn,
    operator: TransitOperator.VIKING_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 11 }).as('seconds'),
  },
  {
    uuid: '1879b27d-4fc2-4135-8091-aab2944b6552',
    type: OrderPointType.FERRY,
    from: FERRIES.helsinki,
    to: FERRIES.stockholm,
    operator: TransitOperator.VIKING_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 17 }).as('seconds'),
  },
  {
    uuid: '8f76386f-1fb7-46f7-a029-82b5fbe8e3e3',
    type: OrderPointType.FERRY,
    from: FERRIES.helsinki,
    to: FERRIES.tallinn,
    operator: TransitOperator.ECKERO_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 3 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  {
    uuid: '773010ec-4f76-4fda-8961-0fe3c1638e8f',
    type: OrderPointType.FERRY,
    from: FERRIES.helsinki,
    to: FERRIES.travemunde,
    operator: TransitOperator.FINNLINES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 35 }).as('seconds'),
  },
  {
    uuid: '040d41a5-945b-4715-a765-5cabee066a32',
    type: OrderPointType.FERRY,
    from: FERRIES.helsinki,
    to: FERRIES.zeebrugge,
    operator: TransitOperator.FINNLINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 200 }).as('seconds'),
  },
  // Helsinki Vuosaari
  {
    uuid: 'a9b7fe09-e223-4b84-8520-c1a98b0cccce',
    type: OrderPointType.FERRY,
    from: FERRIES.helsinkiVuosaari,
    to: FERRIES.muuga,
    operator: TransitOperator.ECKERO_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 15 },
    duration: Duration.fromObject({ hours: 3 }).as('seconds'),
  },
  {
    uuid: 'f7f7bfd4-e344-4720-8259-a009ff021afa',
    type: OrderPointType.FERRY,
    from: FERRIES.helsinkiVuosaari,
    to: FERRIES.sheerness,
    operator: TransitOperator.FINNLINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 181 }).as('seconds'),
  },
  // Långnäs
  {
    uuid: 'c446cdad-403f-4099-98dd-7a91ac03192c',
    type: OrderPointType.FERRY,
    from: FERRIES.langnas,
    to: FERRIES.stockholm,
    operator: TransitOperator.VIKING_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 5 }).as('seconds'),
  },
  {
    uuid: '386e67cf-eb1e-4677-8aac-03a21d84af17',
    type: OrderPointType.FERRY,
    from: FERRIES.langnas,
    to: FERRIES.turku,
    operator: TransitOperator.VIKING_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 4 }).as('seconds'),
  },
  // Mariehamn
  {
    uuid: '78741b50-c53e-4ee8-a08f-2c3c1a7bb9d6',
    type: OrderPointType.FERRY,
    from: FERRIES.mariehamn,
    to: FERRIES.helsinki,
    operator: TransitOperator.VIKING_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 11 }).as('seconds'),
  },
  {
    uuid: 'e2ac5e7f-1c42-433d-a2ea-e6d7ecc90a80',
    type: OrderPointType.FERRY,
    from: FERRIES.mariehamn,
    to: FERRIES.stockholm,
    operator: TransitOperator.VIKING_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 6 }).as('seconds'),
  },
  {
    uuid: '1562461f-c14e-4669-8053-9fb758a207f6',
    type: OrderPointType.FERRY,
    from: FERRIES.mariehamn,
    to: FERRIES.tallinn,
    operator: TransitOperator.TALLINK_SILJA_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 10 }).as('seconds'),
  },
  {
    uuid: '3b4f5740-cec6-4872-bcf2-d0eb7ab9428d',
    type: OrderPointType.FERRY,
    from: FERRIES.mariehamn,
    to: FERRIES.turku,
    operator: TransitOperator.VIKING_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 5 }).as('seconds'),
  },
  // Turku
  {
    uuid: 'e0a41be0-ea48-467a-a712-a2a980f464e7',
    type: OrderPointType.FERRY,
    from: FERRIES.turku,
    to: FERRIES.langnas,
    operator: TransitOperator.VIKING_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 4 }).as('seconds'),
  },
  {
    uuid: '74c00020-32e2-43ec-b63e-73ab1e2dd0e8',
    type: OrderPointType.FERRY,
    from: FERRIES.turku,
    to: FERRIES.mariehamn,
    operator: TransitOperator.VIKING_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 5 }).as('seconds'),
  },
  {
    uuid: '37593f05-e609-4bc7-a39c-edb04013cc8d',
    type: OrderPointType.FERRY,
    from: FERRIES.turku,
    to: FERRIES.stockholm,
    operator: TransitOperator.VIKING_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 11 }).as('seconds'),
  },
  // Vaasa
  {
    uuid: 'd73641fe-885e-4087-9106-20d343c6b176',
    type: OrderPointType.FERRY,
    from: FERRIES.vaasa,
    to: FERRIES.umea,
    operator: TransitOperator.WASALINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 4 }).as('seconds'),
  },

  /* France */
  // Caen
  {
    uuid: '7d7b0407-08f8-43ca-985d-959b3efeaaeb',
    type: OrderPointType.FERRY,
    from: FERRIES.caen,
    to: FERRIES.portsmouth,
    operator: TransitOperator.BRITTANY_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 3 },
    duration: Duration.fromObject({ hours: 6 }).as('seconds'),
  },
  // Calais
  {
    uuid: '89ca70ca-1c96-4872-8c5d-aa23217c68a6',
    type: OrderPointType.FERRY,
    from: FERRIES.calais,
    to: FERRIES.dover,
    operator: TransitOperator.IRISH_FERRIES,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  {
    uuid: 'e95d44dc-36f7-481b-a407-a266ce52ee8e',
    type: OrderPointType.FERRY,
    from: FERRIES.calais,
    to: FERRIES.folkestone,
    operator: TransitOperator.LESHUTTLE_EUROTUNNEL_FREIGHT,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 35 }).as('seconds'),
  },
  {
    uuid: 'f12c5d82-0d9b-4762-83be-a60bec0c2b9b',
    type: OrderPointType.FERRY,
    from: FERRIES.calais,
    to: FERRIES.folkestone,
    operator: TransitOperator.LESHUTTLE_EUROTUNNEL_FREIGHT_VP_FLEXI,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 35 }).as('seconds'),
  },
  {
    uuid: 'b28808c9-9458-4a74-98d5-8502a3850703',
    type: OrderPointType.FERRY,
    from: FERRIES.calais,
    to: FERRIES.folkestone,
    operator: TransitOperator.LESHUTTLE_EUROTUNNEL_FREIGHT_VANS_ON_PASSENGER_VP,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 30 }).as('seconds'),
  },
  // Cherbourg
  {
    uuid: '0ace235c-8683-475b-b64c-54ba3064c529',
    type: OrderPointType.FERRY,
    from: FERRIES.cherbourg,
    to: FERRIES.dublin,
    operator: TransitOperator.IRISH_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 4 },
    duration: Duration.fromObject({ hours: 19 }).as('seconds'),
  },
  {
    uuid: '15839df1-8dcf-4f4d-b2b7-8b9224b8ce74',
    type: OrderPointType.FERRY,
    from: FERRIES.cherbourg,
    to: FERRIES.poole,
    operator: TransitOperator.BRITTANY_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 7 }).as('seconds'),
  },
  {
    uuid: 'c945510a-4795-4863-8b1e-1dfa5b7a111b',
    type: OrderPointType.FERRY,
    from: FERRIES.cherbourg,
    to: FERRIES.portsmouth,
    operator: TransitOperator.BRITTANY_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 5 }).as('seconds'),
  },
  {
    uuid: '00bae029-e380-42ac-a1aa-7de941667fd1',
    type: OrderPointType.FERRY,
    from: FERRIES.cherbourg,
    to: FERRIES.rosslare,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 20 }).as('seconds'),
  },
  // Dieppe
  {
    uuid: '0f48d755-469b-4e25-83ee-35cb82649d34',
    type: OrderPointType.FERRY,
    from: FERRIES.dieppe,
    to: FERRIES.newhaven,
    operator: TransitOperator.DFDS_LD_LINES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 4 }).as('seconds'),
  },
  // Dunkirk
  {
    uuid: 'b20dff3d-3ec0-43b1-ad02-d9a7ee5a8340',
    type: OrderPointType.FERRY,
    from: FERRIES.dunkirk,
    to: FERRIES.dover,
    operator: TransitOperator.DFDS_SEAWAYS_DOVER,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  {
    uuid: 'e5ab236d-b516-4d8c-aa7b-810541f50f3d',
    type: OrderPointType.FERRY,
    from: FERRIES.dunkirk,
    to: FERRIES.rosslare,
    operator: TransitOperator.DFDS_LD_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 24 }).as('seconds'),
  },
  // Le Havre
  {
    uuid: '3cb16f61-bcfe-46dd-8fac-2cb73eecc5bb',
    type: OrderPointType.FERRY,
    from: FERRIES.leHavre,
    to: FERRIES.portsmouth,
    operator: TransitOperator.BRITTANY_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 4 },
    duration: Duration.fromObject({ hours: 10 }).as('seconds'),
  },
  // Marseille
  {
    uuid: 'c7637e5e-c9a6-40b4-b4a0-468f70a7b5b7',
    type: OrderPointType.FERRY,
    from: FERRIES.marseille,
    to: FERRIES.ajaccio,
    operator: TransitOperator.CORSICA_LINEA,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 13 }).as('seconds'),
  },
  {
    uuid: 'e3790db1-07df-4b98-8906-119cdc3f485e',
    type: OrderPointType.FERRY,
    from: FERRIES.marseille,
    to: FERRIES.bastia,
    operator: TransitOperator.CORSICA_LINEA,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 13 }).as('seconds'),
  },
  {
    uuid: '2e2f7b34-dfc5-43ef-8cba-53bc88adf8eb',
    type: OrderPointType.FERRY,
    from: FERRIES.marseille,
    to: FERRIES.ileRousse,
    operator: TransitOperator.CORSICA_LINEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 12 }).as('seconds'),
  },
  {
    uuid: '95903dce-9813-4cde-9a62-de1fe902f42e',
    type: OrderPointType.FERRY,
    from: FERRIES.marseille,
    to: FERRIES.portoVecchio,
    operator: TransitOperator.LA_MERIDIONALE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 14 }).as('seconds'),
  },
  // Unsupported destination country
  // {
  //   uuid: 'c9e2d9c9-6cfc-49f6-87c1-1d5eebccdb95',
  //   type: OrderPointType.FERRY,
  //   from: FERRIES.marseille,
  //   to: FERRIES.tangerMed,
  //   operator: TransitOperator.LA_MERIDIONALE,
  //   frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
  //   duration: Duration.fromObject({ hours: 45 }).as('seconds'),
  // },
  // Unsupported destination country
  // {
  //   uuid: '7475d5cf-0c93-4c9c-b5e9-39a0516d182b',
  //   type: OrderPointType.FERRY,
  //   from: FERRIES.marseille,
  //   to: FERRIES.tunis,
  //   operator: TransitOperator.DFDS_SEAWAYS_MEDITERRANEAN,
  //   frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
  //   duration: Duration.fromObject({ hours: 34 }).as('seconds'),
  // },
  // Roscoff
  {
    uuid: '590a2cdf-7f11-4358-b1bf-1bce6c73a6aa',
    type: OrderPointType.FERRY,
    from: FERRIES.roscoff,
    to: FERRIES.plymouth,
    operator: TransitOperator.BRITTANY_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  // Sète
  {
    uuid: '93dbdf67-e6ad-46c7-8a95-69d431fc709c',
    type: OrderPointType.FERRY,
    from: FERRIES.sete,
    to: FERRIES.alsancak,
    operator: TransitOperator.DFDS_SEAWAYS_MEDITERRANEAN,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 109 }).as('seconds'),
  },
  // Unsupported destination country
  // {
  //   uuid: '2e3f1c04-b541-4f68-9138-7c5db736fcae',
  //   type: OrderPointType.FERRY,
  //   from: FERRIES.sete,
  //   to: FERRIES.tangerMed,
  //   operator: TransitOperator.GRANDI_NAVI_VELOCI,
  //   frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
  //   duration: Duration.fromObject({ hours: 46 }).as('seconds'),
  // },
  // St Malo
  {
    uuid: '3ff99af1-275d-4ceb-b0db-cafbd418ae0a',
    type: OrderPointType.FERRY,
    from: FERRIES.stMalo,
    to: FERRIES.guernsey,
    operator: TransitOperator.CONDOR_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 4 }).as('seconds'),
  },
  {
    uuid: 'f399406c-8330-44f5-982b-4b1e40c073c2',
    type: OrderPointType.FERRY,
    from: FERRIES.stMalo,
    to: FERRIES.jersey,
    operator: TransitOperator.DFDS_JERSEY,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 8 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  {
    uuid: '9c542057-f8b1-480d-a5e5-271250e1e96d',
    type: OrderPointType.FERRY,
    from: FERRIES.stMalo,
    to: FERRIES.portsmouth,
    operator: TransitOperator.BRITTANY_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 10 }).as('seconds'),
  },
  // Toulon
  {
    uuid: '6dc7d62d-2e7e-4adb-b9c1-74ac15414191',
    type: OrderPointType.FERRY,
    from: FERRIES.toulon,
    to: FERRIES.ajaccio,
    operator: TransitOperator.CORSICA_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 11 }).as('seconds'),
  },
  {
    uuid: 'd6ef185b-71d9-47d8-b6c3-55fb9784fbba',
    type: OrderPointType.FERRY,
    from: FERRIES.toulon,
    to: FERRIES.bastia,
    operator: TransitOperator.CORSICA_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 12 }).as('seconds'),
  },

  /* Georgia */
  // Batumi
  {
    uuid: '1d6a957d-6c79-4bf5-9a29-5f2f2bc98c3c',
    type: OrderPointType.FERRY,
    from: FERRIES.batumi,
    to: FERRIES.burgas,
    operator: TransitOperator.PB_MANAGEMENT,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 72 }).as('seconds'),
  },
  {
    uuid: '5531363a-2485-4727-9f19-8d94286a3699',
    type: OrderPointType.FERRY,
    from: FERRIES.batumi,
    to: FERRIES.varna,
    operator: TransitOperator.UKRFERRY,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 43 }).as('seconds'),
  },
  // Poti
  {
    uuid: '6c6c0b88-6b9d-4f25-b20f-deb1b534a035',
    type: OrderPointType.FERRY,
    from: FERRIES.poti,
    to: FERRIES.constanta,
    operator: TransitOperator.E60_SHIPPING_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 48 }).as('seconds'),
  },

  /* Germany */
  // Cuxhaven
  {
    uuid: 'ff2cc3d5-b525-4f7c-ba9d-eff1ae2a4cbd',
    type: OrderPointType.FERRY,
    from: FERRIES.cuxhaven,
    to: FERRIES.immingham,
    operator: TransitOperator.DFDS_SEAWAYS_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 26 }).as('seconds'),
  },
  // Kiel
  {
    uuid: '9ae00e18-f0ab-41b8-9c34-0990894068e7',
    type: OrderPointType.FERRY,
    from: FERRIES.kiel,
    to: FERRIES.gothenburg,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 15 }).as('seconds'),
  },
  {
    uuid: '103138b5-fda4-4c9f-a472-8f9bfccdae73',
    type: OrderPointType.FERRY,
    from: FERRIES.kiel,
    to: FERRIES.klaipeda,
    operator: TransitOperator.DFDS_SEAWAYS_BALTIC_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 21 }).as('seconds'),
  },
  {
    uuid: 'f9a68e80-cd55-47af-8cd3-3b12ab2116f2',
    type: OrderPointType.FERRY,
    from: FERRIES.kiel,
    to: FERRIES.oslo,
    operator: TransitOperator.COLOR_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 20 }).as('seconds'),
  },
  // List
  {
    uuid: '253c934c-b2c3-40b1-b4bb-c32daf4e3842',
    type: OrderPointType.FERRY,
    from: FERRIES.list,
    to: FERRIES.havneby,
    operator: TransitOperator.SYLT_FERRY,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 14 },
    duration: Duration.fromObject({ hours: 1 }).as('seconds'),
  },
  // Puttgarden
  {
    uuid: 'cb51693f-f116-472c-9cab-0bc106f1ce07',
    type: OrderPointType.FERRY,
    from: FERRIES.puttgarden,
    to: FERRIES.helsingborg,
    operator: TransitOperator.SCANDLINES,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ hours: 1 }).as('seconds'),
  },
  {
    uuid: '3aad1d45-6653-4e71-81d7-c69037a6d10c',
    type: OrderPointType.FERRY,
    from: FERRIES.puttgarden,
    to: FERRIES.malmo,
    operator: TransitOperator.SCANDLINES,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 45 }).as('seconds'),
  },
  {
    uuid: '8a006704-f8bc-4aff-a1c7-cc1731508c9a',
    type: OrderPointType.FERRY,
    from: FERRIES.puttgarden,
    to: FERRIES.rodby,
    operator: TransitOperator.SCANDLINES,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 45 }).as('seconds'),
  },
  // Rostock
  {
    uuid: 'f93120cb-f219-4dfd-b2b6-3d5c265182e7',
    type: OrderPointType.FERRY,
    from: FERRIES.rostock,
    to: FERRIES.gedser,
    operator: TransitOperator.SCANDLINES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 10 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  {
    uuid: '2a3f0626-c5b8-47e6-a151-e0820b2cd6b3',
    type: OrderPointType.FERRY,
    from: FERRIES.rostock,
    to: FERRIES.hanko,
    operator: TransitOperator.TRANSFENNICA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 68 }).as('seconds'),
  },
  {
    uuid: 'abe63bcd-25cd-4589-b397-dfae00bd533f',
    type: OrderPointType.FERRY,
    from: FERRIES.rostock,
    to: FERRIES.helsingborg,
    operator: TransitOperator.SCANDLINES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 10 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  {
    uuid: 'bd597c12-b18c-47ce-91db-ceb99dc16116',
    type: OrderPointType.FERRY,
    from: FERRIES.rostock,
    to: FERRIES.karlshamn,
    operator: TransitOperator.TT_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 20 }).as('seconds'),
  },
  {
    uuid: '0505645f-3a83-467f-9569-29d863225e20',
    type: OrderPointType.FERRY,
    from: FERRIES.rostock,
    to: FERRIES.klaipeda,
    operator: TransitOperator.TT_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 35 }).as('seconds'),
  },
  {
    uuid: '57a63380-07a7-4551-bcbe-7b0ead100986',
    type: OrderPointType.FERRY,
    from: FERRIES.rostock,
    to: FERRIES.malmo,
    operator: TransitOperator.SCANDLINES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 10 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  {
    uuid: '6a142487-9895-443c-8bf7-f368cddbf95f',
    type: OrderPointType.FERRY,
    from: FERRIES.rostock,
    to: FERRIES.trelleborg,
    operator: TransitOperator.TT_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 3 },
    duration: Duration.fromObject({ hours: 6 }).as('seconds'),
  },
  // Travemunde
  {
    uuid: '767f58b9-02ef-428f-94ce-b170387fb7ee',
    type: OrderPointType.FERRY,
    from: FERRIES.travemunde,
    to: FERRIES.helsinki,
    operator: TransitOperator.FINNLINES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 35 }).as('seconds'),
  },
  {
    uuid: 'f980ac06-e795-4959-82b6-064d394aee60',
    type: OrderPointType.FERRY,
    from: FERRIES.travemunde,
    to: FERRIES.karlshamn,
    operator: TransitOperator.TT_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 17 }).as('seconds'),
  },
  {
    uuid: 'd3afb74f-8a11-411b-8150-e3b42ec816c1',
    type: OrderPointType.FERRY,
    from: FERRIES.travemunde,
    to: FERRIES.klaipeda,
    operator: TransitOperator.TT_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 28 }).as('seconds'),
  },
  {
    uuid: '24ca8d9b-6731-4ac7-af41-14e926cf1d4c',
    type: OrderPointType.FERRY,
    from: FERRIES.travemunde,
    to: FERRIES.liepaja,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 23 }).as('seconds'),
  },
  {
    uuid: 'd4f2236e-f29b-42be-a035-477744089f10',
    type: OrderPointType.FERRY,
    from: FERRIES.travemunde,
    to: FERRIES.malmo,
    operator: TransitOperator.NORDOLINK,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 3 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  {
    uuid: '0b9119e9-eef7-4ddb-8dae-9dae86dfbeac',
    type: OrderPointType.FERRY,
    from: FERRIES.travemunde,
    to: FERRIES.trelleborg,
    operator: TransitOperator.TT_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 4 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },

  /* Greece */
  // Igoumenitsa
  {
    uuid: 'ab5732f2-9520-415b-b333-9bee78d0580a',
    type: OrderPointType.FERRY,
    from: FERRIES.igoumenitsa,
    to: FERRIES.ancona,
    operator: TransitOperator.MINOAN_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 21 }).as('seconds'),
  },
  {
    uuid: 'f97addc8-b621-42e9-9b14-b155aceb0c45',
    type: OrderPointType.FERRY,
    from: FERRIES.igoumenitsa,
    to: FERRIES.barcelona,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 44 }).as('seconds'),
  },
  {
    uuid: 'a8a02ba2-c57c-4650-92c3-92f06a84a660',
    type: OrderPointType.FERRY,
    from: FERRIES.igoumenitsa,
    to: FERRIES.bari,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 11 }).as('seconds'),
  },
  {
    uuid: '59b9b2f3-5c08-4c14-9271-93af3a7cecbe',
    type: OrderPointType.FERRY,
    from: FERRIES.igoumenitsa,
    to: FERRIES.brindisi,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 10 }).as('seconds'),
  },
  {
    uuid: 'e2e852a3-c102-4130-9133-f9a3a33e4e02',
    type: OrderPointType.FERRY,
    from: FERRIES.igoumenitsa,
    to: FERRIES.corfu,
    operator: TransitOperator.CORFU_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 8 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  {
    uuid: 'f1b149c1-5b1e-4079-974b-d7e8a29d18a4',
    type: OrderPointType.FERRY,
    from: FERRIES.igoumenitsa,
    to: FERRIES.ravenna,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 45 }).as('seconds'),
  },
  {
    uuid: 'bf4380c1-8b26-4c1e-8504-fb03fcf2588f',
    type: OrderPointType.FERRY,
    from: FERRIES.igoumenitsa,
    to: FERRIES.venice,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 38 }).as('seconds'),
  },
  // Lavrio
  {
    uuid: 'ddb055dd-1d1e-4a2a-93b4-14de51817ac5',
    type: OrderPointType.FERRY,
    from: FERRIES.lavrio,
    to: FERRIES.limassol,
    operator: TransitOperator.SALAMIS_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 38 }).as('seconds'),
  },
  // Patras
  {
    uuid: '9af1b2c0-1591-4f95-8ded-d7b1add0cdc7',
    type: OrderPointType.FERRY,
    from: FERRIES.patras,
    to: FERRIES.ancona,
    operator: TransitOperator.ANEK_SUPERFAST_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 12 },
    duration: Duration.fromObject({ hours: 25 }).as('seconds'),
  },
  {
    uuid: '6a90ee3d-d375-4c76-9593-05ef4fcbcf8a',
    type: OrderPointType.FERRY,
    from: FERRIES.patras,
    to: FERRIES.bari,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 47 }).as('seconds'),
  },
  {
    uuid: '0f118812-f4dd-41d6-9450-f4c41475f946',
    type: OrderPointType.FERRY,
    from: FERRIES.patras,
    to: FERRIES.pendik,
    operator: TransitOperator.DFDS_SEAWAYS_MEDITERRANEAN,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 28 }).as('seconds'),
  },
  {
    uuid: 'b2a9f6a3-1a31-4882-ac01-40eb1b9608f2',
    type: OrderPointType.FERRY,
    from: FERRIES.patras,
    to: FERRIES.trieste,
    operator: TransitOperator.DFDS_SEAWAYS_MEDITERRANEAN,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 47 }).as('seconds'),
  },
  {
    uuid: '8add0074-8324-48e8-93f1-b94d8c24a81e',
    type: OrderPointType.FERRY,
    from: FERRIES.patras,
    to: FERRIES.venice,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 46 }).as('seconds'),
  },
  // Piraeus
  {
    uuid: '00a9b131-6960-40f6-ac21-0f40a7fd8f25',
    type: OrderPointType.FERRY,
    from: FERRIES.piraeus,
    to: FERRIES.chania,
    operator: TransitOperator.BLUE_STAR_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  {
    uuid: 'd408e296-4e2f-4e36-860c-4ac6f215090b',
    type: OrderPointType.FERRY,
    from: FERRIES.piraeus,
    to: FERRIES.heraklion,
    operator: TransitOperator.ANEK_SUPERFAST_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  {
    uuid: '6d81509e-f62f-45fd-b29f-f39a571b0d13',
    type: OrderPointType.FERRY,
    from: FERRIES.piraeus,
    to: FERRIES.mykonos,
    operator: TransitOperator.HELLENIC_SEAWAYS,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 6 }).as('seconds'),
  },
  {
    uuid: '1af31bac-08fb-4285-993d-a2e04c39583e',
    type: OrderPointType.FERRY,
    from: FERRIES.piraeus,
    to: FERRIES.rhodes,
    operator: TransitOperator.BLUE_STAR_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 7 },
    duration: Duration.fromObject({ hours: 17 }).as('seconds'),
  },
  // Rhodes
  {
    uuid: 'c9935da8-914e-4d85-bec2-c88bf096e426',
    type: OrderPointType.FERRY,
    from: FERRIES.rhodes,
    to: FERRIES.piraeus,
    operator: TransitOperator.BLUE_STAR_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 17 }).as('seconds'),
  },
  // Thessaloniki
  {
    uuid: '0609ff93-0301-43ac-9270-a5d6de0cdbd2',
    type: OrderPointType.FERRY,
    from: FERRIES.thessaloniki,
    to: FERRIES.limassol,
    operator: TransitOperator.SALAMIS_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 45 }).as('seconds'),
  },

  /* Greek Islands */
  // Chania
  {
    uuid: 'ed49cb9f-60c6-4331-aec0-2b95a25cf42b',
    type: OrderPointType.FERRY,
    from: FERRIES.chania,
    to: FERRIES.piraeus,
    operator: TransitOperator.CRETA_CARGO_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 12 }).as('seconds'),
  },
  // Corfu
  {
    uuid: '0d333173-adef-481f-8243-847d462250b3',
    type: OrderPointType.FERRY,
    from: FERRIES.corfu,
    to: FERRIES.igoumenitsa,
    operator: TransitOperator.CORFU_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 8 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  // Heraklion
  {
    uuid: '00fc784c-cb2d-43fc-8224-f8fbac5531eb',
    type: OrderPointType.FERRY,
    from: FERRIES.heraklion,
    to: FERRIES.piraeus,
    operator: TransitOperator.CRETA_CARGO_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 16 }).as('seconds'),
  },
  // Mykonos
  {
    uuid: '206ffbf8-a38d-4cb4-b2e5-0f4ffe3301c7',
    type: OrderPointType.FERRY,
    from: FERRIES.mykonos,
    to: FERRIES.piraeus,
    operator: TransitOperator.HELLENIC_SEAWAYS,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 6 }).as('seconds'),
  },

  /* Iceland */
  // Seyðisfjörður
  {
    uuid: '74ca1df8-9b3c-46d2-95e8-727f05b4ea9b',
    type: OrderPointType.FERRY,
    from: FERRIES.seydisfjordur,
    to: FERRIES.hirtshals,
    operator: TransitOperator.SMYRIL_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 62 }).as('seconds'),
  },
  // Thorlakshofn
  {
    uuid: '16502baf-fd61-42f2-8900-5557dca697aa',
    type: OrderPointType.FERRY,
    from: FERRIES.thorlakshofn,
    to: FERRIES.rotterdamEuropoortMerseyweg,
    operator: TransitOperator.SMYRIL_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 69 }).as('seconds'),
  },

  /* Isle of Man */
  // Douglas
  {
    uuid: '3efc5963-42f4-4476-b231-876f3f1a239b',
    type: OrderPointType.FERRY,
    from: FERRIES.douglas,
    to: FERRIES.heysham,
    operator: TransitOperator.ISLE_OF_MAN_STEAM_PACKET,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 4 }).as('seconds'),
  },

  /* Isle of Wight */
  // East Cowes
  {
    uuid: '124c9f2a-962a-4afc-ab7b-f34c2b4b1546',
    type: OrderPointType.FERRY,
    from: FERRIES.eastCowes,
    to: FERRIES.southampton,
    operator: TransitOperator.RED_FUNNEL_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 24 },
    duration: Duration.fromObject({ hours: 1 }).as('seconds'),
  },
  // Fishbourne
  {
    uuid: '2feb175d-a7f3-4ac7-b589-43a0cf6b50fe',
    type: OrderPointType.FERRY,
    from: FERRIES.fishbourne,
    to: FERRIES.portsmouth,
    operator: TransitOperator.WIGHTLINK_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 27 },
    duration: Duration.fromObject({ hours: 1 }).as('seconds'),
  },
  // Yarmouth
  {
    uuid: 'b43bc5dc-465f-4eb3-bfda-bec9b1d71465',
    type: OrderPointType.FERRY,
    from: FERRIES.yarmouth,
    to: FERRIES.lymington,
    operator: TransitOperator.WIGHTLINK_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 16 },
    duration: Duration.fromObject({ minutes: 40 }).as('seconds'),
  },

  /* Italy */
  // Ancona
  {
    uuid: '915249db-19c3-47e9-abff-318f7bddbfa4',
    type: OrderPointType.FERRY,
    from: FERRIES.ancona,
    to: FERRIES.durres,
    operator: TransitOperator.ARDIA_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 16 }).as('seconds'),
  },
  {
    uuid: '45dbd4d3-ea20-4000-b825-6a68c402d855',
    type: OrderPointType.FERRY,
    from: FERRIES.ancona,
    to: FERRIES.igoumenitsa,
    operator: TransitOperator.MINOAN_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 22 }).as('seconds'),
  },
  {
    uuid: '2a4d11a1-cf38-4070-aed7-587c5d4c734a',
    type: OrderPointType.FERRY,
    from: FERRIES.ancona,
    to: FERRIES.patras,
    operator: TransitOperator.ANEK_SUPERFAST_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 12 },
    duration: Duration.fromObject({ hours: 25 }).as('seconds'),
  },
  // Bari
  {
    uuid: '6a82a43c-23d8-42a5-8070-2ce59bc97c2f',
    type: OrderPointType.FERRY,
    from: FERRIES.bari,
    to: FERRIES.durres,
    operator: TransitOperator.GRANDI_NAVI_VELOCI,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 10 }).as('seconds'),
  },
  {
    uuid: '541f39ac-45b8-43b0-9a6a-532c08e5b5b0',
    type: OrderPointType.FERRY,
    from: FERRIES.bari,
    to: FERRIES.igoumenitsa,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 24 }).as('seconds'),
  },
  {
    uuid: 'ddc3b7ed-6e46-4fa9-a63b-a650e0ec13aa',
    type: OrderPointType.FERRY,
    from: FERRIES.bari,
    to: FERRIES.patras,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 19 }).as('seconds'),
  },
  {
    uuid: 'f71bae94-850a-4a0f-9366-c0d22db1eec2',
    type: OrderPointType.FERRY,
    from: FERRIES.bari,
    to: FERRIES.pendik,
    operator: TransitOperator.DFDS_SEAWAYS_MEDITERRANEAN,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 45 }).as('seconds'),
  },
  {
    uuid: '00b69b1e-49ec-403a-a604-7f0d53ec8015',
    type: OrderPointType.FERRY,
    from: FERRIES.bari,
    to: FERRIES.ravenna,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 26 }).as('seconds'),
  },
  {
    uuid: '60850145-3c6d-4585-8678-f08cfa45b190',
    type: OrderPointType.FERRY,
    from: FERRIES.bari,
    to: FERRIES.venice,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 23 }).as('seconds'),
  },
  // Brindisi
  {
    uuid: '17a16628-e179-4d1b-8bdc-631080eb8314',
    type: OrderPointType.FERRY,
    from: FERRIES.brindisi,
    to: FERRIES.catania,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 17 }).as('seconds'),
  },
  {
    uuid: '4bf32322-ce45-4e3b-b7b3-b4ab82df5d94',
    type: OrderPointType.FERRY,
    from: FERRIES.brindisi,
    to: FERRIES.igoumenitsa,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 8 }).as('seconds'),
  },
  {
    uuid: '39eba5b7-330f-491c-851a-c2286306f182',
    type: OrderPointType.FERRY,
    from: FERRIES.brindisi,
    to: FERRIES.ravenna,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 22 }).as('seconds'),
  },
  // Civitavecchia
  {
    uuid: '0e8f2228-4588-4093-bf02-0c2b2ffc8952',
    type: OrderPointType.FERRY,
    from: FERRIES.civitavecchia,
    to: FERRIES.arbatax,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  {
    uuid: 'a2f2df35-2452-4c0d-928a-163fcc905a47',
    type: OrderPointType.FERRY,
    from: FERRIES.civitavecchia,
    to: FERRIES.barcelona,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 23 }).as('seconds'),
  },
  {
    uuid: '6efe025d-38b7-489f-b4e6-9f0c14f414ea',
    type: OrderPointType.FERRY,
    from: FERRIES.civitavecchia,
    to: FERRIES.cagliari,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 14 }).as('seconds'),
  },
  {
    uuid: '210e7d89-2dfe-481b-aa8d-0abe5c0f951b',
    type: OrderPointType.FERRY,
    from: FERRIES.civitavecchia,
    to: FERRIES.olbia,
    operator: TransitOperator.TIRRENIA_LINES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 8 }).as('seconds'),
  },
  {
    uuid: '4ccc5cd3-a57b-497e-885c-0599723e93bc',
    type: OrderPointType.FERRY,
    from: FERRIES.civitavecchia,
    to: FERRIES.palermo,
    operator: TransitOperator.GRANDI_NAVI_VELOCI,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 14 }).as('seconds'),
  },
  {
    uuid: 'c147a0bd-050e-4453-b225-d8762858f2b4',
    type: OrderPointType.FERRY,
    from: FERRIES.civitavecchia,
    to: FERRIES.portoTorres,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 10 }).as('seconds'),
  },
  {
    uuid: 'fbcb6dc7-f943-4926-9718-95467fbc8a0c',
    type: OrderPointType.FERRY,
    from: FERRIES.civitavecchia,
    to: FERRIES.terminiImerese,
    operator: TransitOperator.GRANDI_NAVI_VELOCI,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 14 }).as('seconds'),
  },
  // Genoa
  {
    uuid: '423f1ac0-e41c-46a7-b6f7-da19cc5e8a32',
    type: OrderPointType.FERRY,
    from: FERRIES.genoa,
    to: FERRIES.barcelona,
    operator: TransitOperator.GRANDI_NAVI_VELOCI,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 21 }).as('seconds'),
  },
  {
    uuid: 'b7e7ed6b-2f32-4655-b885-42708b4719ba',
    type: OrderPointType.FERRY,
    from: FERRIES.genoa,
    to: FERRIES.cagliari,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 64 }).as('seconds'),
  },
  {
    uuid: 'f287a7e8-a663-4d32-893c-0d012f06a717',
    type: OrderPointType.FERRY,
    from: FERRIES.genoa,
    to: FERRIES.catania,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 40 }).as('seconds'),
  },
  {
    uuid: '52c1be0c-e2c6-4d9b-8ac6-b0bd40dc9abe',
    type: OrderPointType.FERRY,
    from: FERRIES.genoa,
    to: FERRIES.palermo,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 4 },
    duration: Duration.fromObject({ hours: 28 }).as('seconds'),
  },
  {
    uuid: 'e06628be-889d-44e0-b92c-cfe290b0799b',
    type: OrderPointType.FERRY,
    from: FERRIES.genoa,
    to: FERRIES.portoTorres,
    operator: TransitOperator.TIRRENIA_LINES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 11 }).as('seconds'),
  },
  {
    uuid: '1407c3ba-c2c6-4f36-bd2c-e53be93d13c6',
    type: OrderPointType.FERRY,
    from: FERRIES.genoa,
    to: FERRIES.salerno,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 34 }).as('seconds'),
  },
  {
    uuid: 'c946e3ec-63d2-4ed6-8f18-47f79ff685d7',
    type: OrderPointType.FERRY,
    from: FERRIES.genoa,
    to: FERRIES.terminiImerese,
    operator: TransitOperator.GRANDI_NAVI_VELOCI,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 21 }).as('seconds'),
  },
  // Livorno
  {
    uuid: 'f1b33ba6-722c-4a2f-8840-2ea81bfbdaef',
    type: OrderPointType.FERRY,
    from: FERRIES.livorno,
    to: FERRIES.barcelona,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 34 }).as('seconds'),
  },
  {
    uuid: '86af5992-c4d9-4523-a9cb-190343d803f9',
    type: OrderPointType.FERRY,
    from: FERRIES.livorno,
    to: FERRIES.bastia,
    operator: TransitOperator.CORSICA_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 5 }).as('seconds'),
  },
  {
    uuid: 'b1f8ede4-a881-4273-bc47-084b68bead2f',
    type: OrderPointType.FERRY,
    from: FERRIES.livorno,
    to: FERRIES.cagliari,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 19 }).as('seconds'),
  },
  {
    uuid: 'a04ed783-18b7-4b4b-b207-a277d1002fe2',
    type: OrderPointType.FERRY,
    from: FERRIES.livorno,
    to: FERRIES.catania,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 4 },
    duration: Duration.fromObject({ hours: 26 }).as('seconds'),
  },
  {
    uuid: '4ab5d3ad-7a34-4eeb-9c49-a992a8601392',
    type: OrderPointType.FERRY,
    from: FERRIES.livorno,
    to: FERRIES.golfoAranci,
    operator: TransitOperator.CORSICA_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 11 }).as('seconds'),
  },
  {
    uuid: 'ef065401-ef7d-4a0b-aab0-ae45e53b3239',
    type: OrderPointType.FERRY,
    from: FERRIES.livorno,
    to: FERRIES.ileRousse,
    operator: TransitOperator.CORSICA_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 6 }).as('seconds'),
  },
  {
    uuid: '21fca3f8-41b4-4078-9c71-0f447b8fdbb3',
    type: OrderPointType.FERRY,
    from: FERRIES.livorno,
    to: FERRIES.olbia,
    operator: TransitOperator.MOBY_LINES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  {
    uuid: '06389456-c411-4c46-8714-9dc2c2622d06',
    type: OrderPointType.FERRY,
    from: FERRIES.livorno,
    to: FERRIES.palermo,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 4 },
    duration: Duration.fromObject({ hours: 30 }).as('seconds'),
  },
  {
    uuid: 'e7b38628-22f4-49e5-951d-d4d2679efc65',
    type: OrderPointType.FERRY,
    from: FERRIES.livorno,
    to: FERRIES.valencia,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 50 }).as('seconds'),
  },
  // Marina di Carrara
  {
    uuid: 'd8747a41-6e28-4f51-9673-2ac1a8a29494',
    type: OrderPointType.FERRY,
    from: FERRIES.marinaDiCarrara,
    to: FERRIES.cagliari,
    operator: TransitOperator.GRENDI_GROUP,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 29 }).as('seconds'),
  },
  {
    uuid: '6d308dae-f5e9-45d4-bf70-aab931450ac3',
    type: OrderPointType.FERRY,
    from: FERRIES.marinaDiCarrara,
    to: FERRIES.olbia,
    operator: TransitOperator.GRENDI_GROUP,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 4 },
    duration: Duration.fromObject({ hours: 13 }).as('seconds'),
  },
  // Messina
  {
    uuid: '08d389f6-161b-496e-b054-6b0201638bc8',
    type: OrderPointType.FERRY,
    from: FERRIES.messina,
    to: FERRIES.salerno,
    operator: TransitOperator.CARONTE_TOURIST,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 7 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  {
    uuid: '8f20d761-7037-4acb-8786-a1e2e7a56916',
    type: OrderPointType.FERRY,
    from: FERRIES.messina,
    to: FERRIES.villaSanGiovanni,
    operator: TransitOperator.BLUFERRIES,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 50 }).as('seconds'),
  },
  // Naples
  {
    uuid: '75c98a94-3cf2-4371-8d5b-3023a3ff9da2',
    type: OrderPointType.FERRY,
    from: FERRIES.naples,
    to: FERRIES.cagliari,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 15 }).as('seconds'),
  },
  {
    uuid: '5189b7e6-9ed0-4fb1-9f64-d7aa38599568',
    type: OrderPointType.FERRY,
    from: FERRIES.naples,
    to: FERRIES.palermo,
    operator: TransitOperator.TIRRENIA_LINES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 11 }).as('seconds'),
  },
  {
    uuid: '0dd0efbe-eff9-4f2f-b310-c0bc267e4157',
    type: OrderPointType.FERRY,
    from: FERRIES.naples,
    to: FERRIES.terminiImerese,
    operator: TransitOperator.GRANDI_NAVI_VELOCI,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 10 }).as('seconds'),
  },
  // Piombino
  {
    uuid: '68ac47e0-7708-465f-aac0-37215a6ef97b',
    type: OrderPointType.FERRY,
    from: FERRIES.piombino,
    to: FERRIES.bastia,
    operator: TransitOperator.CORSICA_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 3 }).as('seconds'),
  },
  {
    uuid: 'ec42127e-b2dc-44ab-bd8b-30aa7621c878',
    type: OrderPointType.FERRY,
    from: FERRIES.piombino,
    to: FERRIES.portoferraio,
    operator: TransitOperator.MOBY_LINES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 4 },
    duration: Duration.fromObject({ hours: 1 }).as('seconds'),
  },
  // Porto Torres
  {
    uuid: '4c69a2a4-3769-45f2-ac9b-404e083f7547',
    type: OrderPointType.FERRY,
    from: FERRIES.portoTorres,
    to: FERRIES.barcelona,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 14 }).as('seconds'),
  },
  {
    uuid: '4db30141-5985-4606-8d78-ed42a131295c',
    type: OrderPointType.FERRY,
    from: FERRIES.portoTorres,
    to: FERRIES.civitavecchia,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 8 }).as('seconds'),
  },
  {
    uuid: '86e0aa08-5755-4cce-98ce-71dfd7b7a121',
    type: OrderPointType.FERRY,
    from: FERRIES.portoTorres,
    to: FERRIES.genoa,
    operator: TransitOperator.TIRRENIA_LINES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 11 }).as('seconds'),
  },
  {
    uuid: '5faefa9a-5be9-4a2e-9537-70ffcdb83bf8',
    type: OrderPointType.FERRY,
    from: FERRIES.portoTorres,
    to: FERRIES.toulon,
    operator: TransitOperator.CORSICA_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 14 }).as('seconds'),
  },
  // Portoferraio
  {
    uuid: '70e7b6f9-f279-4d63-86cf-dbdc9eb2e364',
    type: OrderPointType.FERRY,
    from: FERRIES.portoferraio,
    to: FERRIES.piombino,
    operator: TransitOperator.MOBY_LINES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 4 },
    duration: Duration.fromObject({ hours: 1 }).as('seconds'),
  },
  // Ravenna
  {
    uuid: '383fcae5-920e-459b-8747-9f141c8c4884',
    type: OrderPointType.FERRY,
    from: FERRIES.ravenna,
    to: FERRIES.bari,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 27 }).as('seconds'),
  },
  {
    uuid: '5f469df3-17b0-4496-a65a-b524b377e3c4',
    type: OrderPointType.FERRY,
    from: FERRIES.ravenna,
    to: FERRIES.brindisi,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 22 }).as('seconds'),
  },
  {
    uuid: 'ed1b9607-0b5b-424d-90dd-eb6a970a69db',
    type: OrderPointType.FERRY,
    from: FERRIES.ravenna,
    to: FERRIES.catania,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 42 }).as('seconds'),
  },
  {
    uuid: '95aa6b2d-92bf-49c6-b16e-5bbe1e1a930d',
    type: OrderPointType.FERRY,
    from: FERRIES.ravenna,
    to: FERRIES.igoumenitsa,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 44 }).as('seconds'),
  },
  // Salerno
  {
    uuid: 'f6c49bbc-3fa8-45d8-a9ad-3584a7c58a46',
    type: OrderPointType.FERRY,
    from: FERRIES.salerno,
    to: FERRIES.cagliari,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 17 }).as('seconds'),
  },
  {
    uuid: '2e677c0a-7707-4fc6-93e6-9989082b5095',
    type: OrderPointType.FERRY,
    from: FERRIES.salerno,
    to: FERRIES.catania,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 13 }).as('seconds'),
  },
  {
    uuid: '29aa1535-fe59-48be-b9be-06d6960b7a79',
    type: OrderPointType.FERRY,
    from: FERRIES.salerno,
    to: FERRIES.genoa,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 25 }).as('seconds'),
  },
  {
    uuid: '2e6aca28-e8f6-439f-998b-b5bf81af00b1',
    type: OrderPointType.FERRY,
    from: FERRIES.salerno,
    to: FERRIES.messina,
    operator: TransitOperator.CARONTE_TOURIST,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  {
    uuid: '8a01218e-cd57-4943-bab3-34d9b98d94ad',
    type: OrderPointType.FERRY,
    from: FERRIES.salerno,
    to: FERRIES.palermo,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 12 }).as('seconds'),
  },
  {
    uuid: '83a810a3-e740-4701-a4f3-4e209a0b7c2b',
    type: OrderPointType.FERRY,
    from: FERRIES.salerno,
    to: FERRIES.sagunto,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 52 }).as('seconds'),
  },
  // Savona
  {
    uuid: 'de67b5fd-af22-4fb2-ac01-7d06531e106d',
    type: OrderPointType.FERRY,
    from: FERRIES.savona,
    to: FERRIES.barcelona,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 19 }).as('seconds'),
  },
  {
    uuid: 'e424ee7d-c74c-431c-b821-7cb593afb911',
    type: OrderPointType.FERRY,
    from: FERRIES.savona,
    to: FERRIES.valencia,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 31 }).as('seconds'),
  },
  // Trieste
  {
    uuid: '841fe4cd-9581-4e08-935b-b8a54aa3954f',
    type: OrderPointType.FERRY,
    from: FERRIES.trieste,
    to: FERRIES.ambarli,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 69 }).as('seconds'),
  },
  {
    uuid: 'da7533b2-08a3-4a71-bf28-1a5be1e9656f',
    type: OrderPointType.FERRY,
    from: FERRIES.trieste,
    to: FERRIES.patras,
    operator: TransitOperator.DFDS_SEAWAYS_MEDITERRANEAN,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 34 }).as('seconds'),
  },
  {
    uuid: 'd424b4fd-c3a4-476c-987c-8cd8fdb6b77e',
    type: OrderPointType.FERRY,
    from: FERRIES.trieste,
    to: FERRIES.pendik,
    operator: TransitOperator.DFDS_SEAWAYS_MEDITERRANEAN,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 65 }).as('seconds'),
  },
  // Venice
  {
    uuid: 'd98a0238-f92d-41ee-9526-499a089e0085',
    type: OrderPointType.FERRY,
    from: FERRIES.venice,
    to: FERRIES.bari,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 20 }).as('seconds'),
  },
  {
    uuid: '97ad52ad-b9bc-4af4-8d66-a863f05b177f',
    type: OrderPointType.FERRY,
    from: FERRIES.venice,
    to: FERRIES.igoumenitsa,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 45 }).as('seconds'),
  },
  {
    uuid: '555b64c6-36ad-4845-9caa-2fae4fd04b5c',
    type: OrderPointType.FERRY,
    from: FERRIES.venice,
    to: FERRIES.patras,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 46 }).as('seconds'),
  },
  // Villa San Giovanni
  {
    uuid: '8ca7cd82-b7ae-42a0-b268-88d5f4a5e8ac',
    type: OrderPointType.FERRY,
    from: FERRIES.villaSanGiovanni,
    to: FERRIES.messina,
    operator: TransitOperator.BLUFERRIES,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 50 }).as('seconds'),
  },
  {
    uuid: '0c4c3750-b89c-49d1-a314-73636109d22a',
    type: OrderPointType.FERRY,
    from: FERRIES.villaSanGiovanni,
    to: FERRIES.tremestieri,
    operator: TransitOperator.BLUFERRIES,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ hours: 1 }).as('seconds'),
  },

  /* Latvia */
  // Liepaja
  {
    uuid: '38220939-c98c-4c07-a568-5cb6d1065c19',
    type: OrderPointType.FERRY,
    from: FERRIES.liepaja,
    to: FERRIES.travemunde,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 21 }).as('seconds'),
  },
  // Ventspils
  {
    uuid: 'c2dffed9-eab1-488b-8c68-a8b05fef322b',
    type: OrderPointType.FERRY,
    from: FERRIES.ventspils,
    to: FERRIES.nynashamn,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },

  /* Lithuania */
  // Klaipeda
  {
    uuid: 'ff50f4ad-1343-4199-98b0-d1a0aafeb329',
    type: OrderPointType.FERRY,
    from: FERRIES.klaipeda,
    to: FERRIES.fredericia,
    operator: TransitOperator.DFDS_SEAWAYS_BALTIC_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 36 }).as('seconds'),
  },
  {
    uuid: '539a220c-3b23-4d7f-b21a-125cfd4f8f1e',
    type: OrderPointType.FERRY,
    from: FERRIES.klaipeda,
    to: FERRIES.karlshamn,
    operator: TransitOperator.DFDS_SEAWAYS_BALTIC_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 14 },
    duration: Duration.fromObject({ hours: 13 }).as('seconds'),
  },
  {
    uuid: '17921bb3-20d6-4bdb-94af-d676e7b47906',
    type: OrderPointType.FERRY,
    from: FERRIES.klaipeda,
    to: FERRIES.kiel,
    operator: TransitOperator.DFDS_SEAWAYS_BALTIC_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 12 },
    duration: Duration.fromObject({ hours: 21 }).as('seconds'),
  },
  {
    uuid: '881349ad-03a1-4069-80e9-3065e8f6b504',
    type: OrderPointType.FERRY,
    from: FERRIES.klaipeda,
    to: FERRIES.koge,
    operator: TransitOperator.DFDS_SEAWAYS_BALTIC_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 21 }).as('seconds'),
  },
  {
    uuid: '7ac21fff-8bee-4fde-9a01-d76f5fc34ebc',
    type: OrderPointType.FERRY,
    from: FERRIES.klaipeda,
    to: FERRIES.rostock,
    operator: TransitOperator.TT_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 33 }).as('seconds'),
  },
  {
    uuid: '694d22d1-bc2e-4453-b9be-f0b0ddfd5ceb',
    type: OrderPointType.FERRY,
    from: FERRIES.klaipeda,
    to: FERRIES.travemunde,
    operator: TransitOperator.TT_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 4 },
    duration: Duration.fromObject({ hours: 31 }).as('seconds'),
  },
  {
    uuid: '4720b70e-0bb0-4936-bd8a-ecbb58c3fe1e',
    type: OrderPointType.FERRY,
    from: FERRIES.klaipeda,
    to: FERRIES.trelleborg,
    operator: TransitOperator.TT_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 19 }).as('seconds'),
  },

  /* Morocco */
  // TODO: Currently unsupported country (outside of Europe)

  /* Netherlands */
  // Hook of Holland
  {
    uuid: '755a6236-44ae-4a8d-8c38-57db294f2c05',
    type: OrderPointType.FERRY,
    from: FERRIES.hookOfHolland,
    to: FERRIES.harwich,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 7 }).as('seconds'),
  },
  {
    uuid: '65af9ffd-e30e-4857-b365-6459312cb7c1',
    type: OrderPointType.FERRY,
    from: FERRIES.hookOfHolland,
    to: FERRIES.killingholme,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 11 }).as('seconds'),
  },
  // Ijmuiden
  {
    uuid: 'eabef8c7-5770-4382-b25c-711a98fb51b8',
    type: OrderPointType.FERRY,
    from: FERRIES.ijmuiden,
    to: FERRIES.newcastle,
    operator: TransitOperator.DFDS_SEAWAYS_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 17 }).as('seconds'),
  },
  // Rotterdam (Europoort & Merseyweg)
  {
    uuid: '13824d02-558d-4ac2-b885-1264240bc6c5',
    type: OrderPointType.FERRY,
    from: FERRIES.rotterdamEuropoortMerseyweg,
    to: FERRIES.harwich,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 10 },
    duration: Duration.fromObject({ hours: 8 }).as('seconds'),
  },
  {
    uuid: 'de8507e0-3d6a-4703-97b9-6572f3f41261',
    type: OrderPointType.FERRY,
    from: FERRIES.rotterdamEuropoortMerseyweg,
    to: FERRIES.hull,
    operator: TransitOperator.PO_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 11 }).as('seconds'),
  },
  {
    uuid: 'e6a0526b-99bc-4093-98bd-6f2fec29e7da',
    type: OrderPointType.FERRY,
    from: FERRIES.rotterdamEuropoortMerseyweg,
    to: FERRIES.immingham,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 14 }).as('seconds'),
  },
  {
    uuid: '330fd5c4-2154-4acf-8725-222340d7c5d0',
    type: OrderPointType.FERRY,
    from: FERRIES.rotterdamEuropoortMerseyweg,
    to: FERRIES.thorlakshofn,
    operator: TransitOperator.SMYRIL_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 78 }).as('seconds'),
  },
  {
    uuid: '96dfbb27-2dd0-4a8a-8db1-ab140f0470c9',
    type: OrderPointType.FERRY,
    from: FERRIES.rotterdamEuropoortMerseyweg,
    to: FERRIES.tilbury,
    operator: TransitOperator.PO_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 10 }).as('seconds'),
  },
  // Rotterdam Vlaardingen
  {
    uuid: '2262c768-9cc5-4b42-8f0e-9930ff7f7a78',
    type: OrderPointType.FERRY,
    from: FERRIES.rotterdamVlaardingen,
    to: FERRIES.felixstowe,
    operator: TransitOperator.DFDS_SEAWAYS_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 3 },
    duration: Duration.fromObject({ hours: 8 }).as('seconds'),
  },
  {
    uuid: 'ca9338ba-e05a-42f8-982c-8944710b6f9e',
    type: OrderPointType.FERRY,
    from: FERRIES.rotterdamVlaardingen,
    to: FERRIES.immingham,
    operator: TransitOperator.DFDS_SEAWAYS_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 14 }).as('seconds'),
  },

  /* Northern Ireland */
  // Belfast
  {
    uuid: '6a85e5d1-5b98-4765-991d-c8f26df5795a',
    type: OrderPointType.FERRY,
    from: FERRIES.belfast,
    to: FERRIES.cairnryan,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 6 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  {
    uuid: '4bfaf847-644a-47e3-adad-814b4e561df4',
    type: OrderPointType.FERRY,
    from: FERRIES.belfast,
    to: FERRIES.heysham,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  {
    uuid: '6dca29c4-8ccf-4f22-bdd1-cce6cffa1411',
    type: OrderPointType.FERRY,
    from: FERRIES.belfast,
    to: FERRIES.liverpoolBirkenhead,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 3 },
    duration: Duration.fromObject({ hours: 8 }).as('seconds'),
  },
  // Larne
  {
    uuid: '6abff592-89b2-473e-98e5-dc5410c18481',
    type: OrderPointType.FERRY,
    from: FERRIES.larne,
    to: FERRIES.cairnryan,
    operator: TransitOperator.PO_IRISH_SEA,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 6 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  // Warrenpoint
  {
    uuid: '066b0cb1-db97-4447-8f80-e4488ebd6e2a',
    type: OrderPointType.FERRY,
    from: FERRIES.warrenpoint,
    to: FERRIES.heysham,
    operator: TransitOperator.CLDN_RORO_SEATRUCK_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 10 }).as('seconds'),
  },

  /* Norway */
  // Brevik
  {
    uuid: '3ab571bc-a58c-4ebe-bf33-900fd74ebd74',
    type: OrderPointType.FERRY,
    from: FERRIES.brevik,
    to: FERRIES.ghent,
    operator: TransitOperator.DFDS_SEAWAYS_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 45 }).as('seconds'),
  },
  {
    uuid: '0ffdba79-0ea5-4b78-adea-e39452f43731',
    type: OrderPointType.FERRY,
    from: FERRIES.brevik,
    to: FERRIES.gothenburg,
    operator: TransitOperator.DFDS_SEAWAYS_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 11 }).as('seconds'),
  },
  {
    uuid: 'aef3570f-19d3-4361-aec7-eb543f68c7be',
    type: OrderPointType.FERRY,
    from: FERRIES.brevik,
    to: FERRIES.immingham,
    operator: TransitOperator.DFDS_SEAWAYS_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 40 }).as('seconds'),
  },
  // Frederikstad
  {
    uuid: 'a29a21b9-7298-4311-8a29-e4c123eaa848',
    type: OrderPointType.FERRY,
    from: FERRIES.frederikstad,
    to: FERRIES.zeebrugge,
    operator: TransitOperator.DFDS_SEAWAYS_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 71 }).as('seconds'),
  },
  // Haugesund
  {
    uuid: '011ba170-b27a-4d0c-83c1-ed54bd320e90',
    type: OrderPointType.FERRY,
    from: FERRIES.haugesund,
    to: FERRIES.immingham,
    operator: TransitOperator.SEA_CARGO,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 68 }).as('seconds'),
  },
  // Kristiansand
  {
    uuid: '7a5f1f9b-636e-4acb-b75e-18cfa32b8d74',
    type: OrderPointType.FERRY,
    from: FERRIES.kristiansand,
    to: FERRIES.hirtshals,
    operator: TransitOperator.FJORD_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 4 }).as('seconds'),
  },
  // Larvik
  {
    uuid: '91bd070b-5a0b-4dbd-9c8d-486c1466a459',
    type: OrderPointType.FERRY,
    from: FERRIES.larvik,
    to: FERRIES.hirtshals,
    operator: TransitOperator.COLOR_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 4 }).as('seconds'),
  },
  // Oslo
  {
    uuid: '33541bf5-1e31-42b4-9c39-7db87386d609',
    type: OrderPointType.FERRY,
    from: FERRIES.oslo,
    to: FERRIES.kiel,
    operator: TransitOperator.COLOR_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 20 }).as('seconds'),
  },
  // Sandefjord
  {
    uuid: '25756d9f-209a-4dc7-9314-a477c98fba21',
    type: OrderPointType.FERRY,
    from: FERRIES.sandefjord,
    to: FERRIES.stromstad,
    operator: TransitOperator.COLOR_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 3 }).as('seconds'),
  },
  // Tananger
  {
    uuid: 'c2cb6389-62e7-4c47-ab9f-90b755403c33',
    type: OrderPointType.FERRY,
    from: FERRIES.tananger,
    to: FERRIES.immingham,
    operator: TransitOperator.SEA_CARGO,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 55 }).as('seconds'),
  },

  /* Poland */
  // Gdańsk
  {
    uuid: 'e01913c4-8c63-49bf-878b-9310b2ed975e',
    type: OrderPointType.FERRY,
    from: FERRIES.gdansk,
    to: FERRIES.nynashamn,
    operator: TransitOperator.POLFERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 18 }).as('seconds'),
  },
  // Gdynia
  {
    uuid: 'c141b810-a758-4b37-b5e4-3be144809885',
    type: OrderPointType.FERRY,
    from: FERRIES.gdynia,
    to: FERRIES.antwerp,
    operator: TransitOperator.TRANSFENNICA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 128 }).as('seconds'),
  },
  {
    uuid: '3e8b0a8e-f2dd-46e8-9d75-ba56ff3669cd',
    type: OrderPointType.FERRY,
    from: FERRIES.gdynia,
    to: FERRIES.hanko,
    operator: TransitOperator.FINNLINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 21 }).as('seconds'),
  },
  {
    uuid: '64a76abf-999d-4af6-aef9-928682c4aac6',
    type: OrderPointType.FERRY,
    from: FERRIES.gdynia,
    to: FERRIES.karlskrona,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 3 },
    duration: Duration.fromObject({ hours: 11 }).as('seconds'),
  },
  // Świnoujście
  {
    uuid: '787f26b3-a96f-4e0d-9ed7-2973ac8f31b7',
    type: OrderPointType.FERRY,
    from: FERRIES.swinoujscie,
    to: FERRIES.copenhagen,
    operator: TransitOperator.POLFERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 7 }).as('seconds'),
  },
  {
    uuid: '01cf13a2-9fa6-4573-8314-0c0705515d8f',
    type: OrderPointType.FERRY,
    from: FERRIES.swinoujscie,
    to: FERRIES.malmo,
    operator: TransitOperator.NORDOLINK,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  {
    uuid: 'b871f94e-8148-485c-972a-bc9528fafb09',
    type: OrderPointType.FERRY,
    from: FERRIES.swinoujscie,
    to: FERRIES.trelleborg,
    operator: TransitOperator.UNITY_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 3 },
    duration: Duration.fromObject({ hours: 7 }).as('seconds'),
  },
  {
    uuid: '813b1eee-b6bc-4ce4-9318-1c5f57b728b5',
    type: OrderPointType.FERRY,
    from: FERRIES.swinoujscie,
    to: FERRIES.ystad,
    operator: TransitOperator.UNITY_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 3 },
    duration: Duration.fromObject({ hours: 7 }).as('seconds'),
  },

  /* Republic of Ireland */
  // Cork
  {
    uuid: '1adff1d5-4088-45e0-a95e-f6e1e9b76ded',
    type: OrderPointType.FERRY,
    from: FERRIES.cork,
    to: FERRIES.zeebrugge,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 27 }).as('seconds'),
  },
  // Dublin
  {
    uuid: '87ac5fb8-4e82-4381-89e2-901880de7efa',
    type: OrderPointType.FERRY,
    from: FERRIES.dublin,
    to: FERRIES.cherbourg,
    operator: TransitOperator.IRISH_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 18 }).as('seconds'),
  },
  {
    uuid: 'be8ee355-4825-4888-87b5-05609f553dfd',
    type: OrderPointType.FERRY,
    from: FERRIES.dublin,
    to: FERRIES.heysham,
    operator: TransitOperator.CLDN_RORO_SEATRUCK_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  {
    uuid: 'a2179abe-375b-4101-8790-6b07ffc1147d',
    type: OrderPointType.FERRY,
    from: FERRIES.dublin,
    to: FERRIES.holyhead,
    operator: TransitOperator.IRISH_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 4 },
    duration: Duration.fromObject({ hours: 4 }).as('seconds'),
  },
  {
    uuid: 'dc608d27-c622-4b29-b360-e70f5488c908',
    type: OrderPointType.FERRY,
    from: FERRIES.dublin,
    to: FERRIES.liverpool,
    operator: TransitOperator.CLDN_RORO_SEATRUCK_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 3 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  {
    uuid: 'c1f1bb24-fdc5-4f79-aaa1-6e81d6701895',
    type: OrderPointType.FERRY,
    from: FERRIES.dublin,
    to: FERRIES.liverpoolBirkenhead,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 8 }).as('seconds'),
  },
  // Rosslare
  {
    uuid: '23e39b06-9ba8-448b-9265-3a55c6b0c3c0',
    type: OrderPointType.FERRY,
    from: FERRIES.rosslare,
    to: FERRIES.bilbao,
    operator: TransitOperator.BRITTANY_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 29 }).as('seconds'),
  },
  {
    uuid: 'add5a986-d71e-4c08-b37f-18c0a07903f9',
    type: OrderPointType.FERRY,
    from: FERRIES.rosslare,
    to: FERRIES.cherbourg,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 20 }).as('seconds'),
  },
  {
    uuid: 'daeba7db-ceb5-4205-b316-dbb27179a2cb',
    type: OrderPointType.FERRY,
    from: FERRIES.rosslare,
    to: FERRIES.dunkirk,
    operator: TransitOperator.DFDS_LD_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 24 }).as('seconds'),
  },
  {
    uuid: 'ae72542f-f820-45d0-894b-02327f51dd55',
    type: OrderPointType.FERRY,
    from: FERRIES.rosslare,
    to: FERRIES.fishguard,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 4 }).as('seconds'),
  },
  {
    uuid: '3c3ee11e-8b95-4537-a6d0-c64580d28480',
    type: OrderPointType.FERRY,
    from: FERRIES.rosslare,
    to: FERRIES.gothenburg,
    operator: TransitOperator.FINNLINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 4 },
    duration: Duration.fromObject({ hours: 111 }).as('seconds'),
  },
  {
    uuid: '1a09ea21-2266-44ba-b261-4e630e327a48',
    type: OrderPointType.FERRY,
    from: FERRIES.rosslare,
    to: FERRIES.pembroke,
    operator: TransitOperator.IRISH_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 4 }).as('seconds'),
  },
  {
    uuid: 'f3133598-4224-4fc4-b14c-76c387bfd144',
    type: OrderPointType.FERRY,
    from: FERRIES.rosslare,
    to: FERRIES.zeebrugge,
    operator: TransitOperator.FINNLINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 19 }).as('seconds'),
  },

  /* Romania */
  // Constanta
  {
    uuid: '068c559f-ea4d-4d46-8c5a-9ac4dcfde979',
    type: OrderPointType.FERRY,
    from: FERRIES.constanta,
    to: FERRIES.karasu,
    operator: TransitOperator.SEA_CARGO,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 16 }).as('seconds'),
  },
  {
    uuid: '180f6169-6432-4bad-acae-2f2f6643b488',
    type: OrderPointType.FERRY,
    from: FERRIES.constanta,
    to: FERRIES.poti,
    operator: TransitOperator.E60_SHIPPING_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 48 }).as('seconds'),
  },

  /* Sardinia */
  // Arbatax
  {
    uuid: '5cf9cedf-5206-4a66-8fdc-412e362f4aaa',
    type: OrderPointType.FERRY,
    from: FERRIES.arbatax,
    to: FERRIES.civitavecchia,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  // Cagliari
  {
    uuid: '313d83ea-824a-462b-8117-9779565ca935',
    type: OrderPointType.FERRY,
    from: FERRIES.cagliari,
    to: FERRIES.civitavecchia,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 14 }).as('seconds'),
  },
  {
    uuid: '7adf63d8-9e36-4284-86ce-969d75844273',
    type: OrderPointType.FERRY,
    from: FERRIES.cagliari,
    to: FERRIES.genoa,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 42 }).as('seconds'),
  },
  {
    uuid: '392cbef1-941b-45ff-ada0-cbb2cac49ecc',
    type: OrderPointType.FERRY,
    from: FERRIES.cagliari,
    to: FERRIES.livorno,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 19 }).as('seconds'),
  },
  {
    uuid: '026d0b5a-1fa1-43c8-a4ea-0a388ffc117e',
    type: OrderPointType.FERRY,
    from: FERRIES.cagliari,
    to: FERRIES.marinaDiCarrara,
    operator: TransitOperator.GRENDI_GROUP,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 28 }).as('seconds'),
  },
  {
    uuid: '54a68909-3f65-4c83-ad12-e344ec0793d5',
    type: OrderPointType.FERRY,
    from: FERRIES.cagliari,
    to: FERRIES.naples,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 15 }).as('seconds'),
  },
  {
    uuid: '208c1213-a0e3-4787-8291-185dcba34f75',
    type: OrderPointType.FERRY,
    from: FERRIES.cagliari,
    to: FERRIES.palermo,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 12 }).as('seconds'),
  },
  {
    uuid: 'f67184e2-373e-42b4-a19e-d32d46c3ef21',
    type: OrderPointType.FERRY,
    from: FERRIES.cagliari,
    to: FERRIES.sagunto,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 31 }).as('seconds'),
  },
  {
    uuid: '6de74431-a3f7-4ac2-a5ce-f208d7c35372',
    type: OrderPointType.FERRY,
    from: FERRIES.cagliari,
    to: FERRIES.salerno,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 14 }).as('seconds'),
  },
  // Golfo Aranci
  {
    uuid: '06ae9a1f-5fb1-4160-8739-6fa501f33ba4',
    type: OrderPointType.FERRY,
    from: FERRIES.golfoAranci,
    to: FERRIES.livorno,
    operator: TransitOperator.CORSICA_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 10 }).as('seconds'),
  },
  // Olbia
  {
    uuid: 'a1596e55-10e4-4171-89dd-330ea44a275b',
    type: OrderPointType.FERRY,
    from: FERRIES.olbia,
    to: FERRIES.civitavecchia,
    operator: TransitOperator.TIRRENIA_LINES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 8 }).as('seconds'),
  },
  {
    uuid: 'bc9de863-4695-4a78-951b-d0cdc9e565bc',
    type: OrderPointType.FERRY,
    from: FERRIES.olbia,
    to: FERRIES.livorno,
    operator: TransitOperator.MOBY_LINES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  {
    uuid: 'b4c26aec-ae0c-46f1-b6e3-bb3231d994a7',
    type: OrderPointType.FERRY,
    from: FERRIES.olbia,
    to: FERRIES.marinaDiCarrara,
    operator: TransitOperator.GRENDI_GROUP,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 12 }).as('seconds'),
  },

  /* Scotland */
  // Aberdeen
  {
    uuid: 'd1cdce66-c6ad-472e-b599-601402988d59',
    type: OrderPointType.FERRY,
    from: FERRIES.aberdeen,
    to: FERRIES.kirkwall,
    operator: TransitOperator.NORTHLINK_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 10 }).as('seconds'),
  },
  {
    uuid: 'ea8039e5-25cd-4898-8efe-494988d89edb',
    type: OrderPointType.FERRY,
    from: FERRIES.aberdeen,
    to: FERRIES.lerwick,
    operator: TransitOperator.NORTHLINK_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 15 }).as('seconds'),
  },
  // Ardrossan
  {
    uuid: 'b19d5f13-6410-4fa0-847e-534250b185bb',
    type: OrderPointType.FERRY,
    from: FERRIES.ardrossan,
    to: FERRIES.brodick,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 6 },
    duration: Duration.fromObject({ minutes: 55 }).as('seconds'),
  },
  // Cairnryan
  {
    uuid: '85fd9263-9ed5-4d6b-90a3-ee7eaf74cce4',
    type: OrderPointType.FERRY,
    from: FERRIES.cairnryan,
    to: FERRIES.belfast,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 6 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  {
    uuid: '182dfa91-f63c-4afe-a498-eb469a8ebb84',
    type: OrderPointType.FERRY,
    from: FERRIES.cairnryan,
    to: FERRIES.larne,
    operator: TransitOperator.PO_IRISH_SEA,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 6 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  // Claonaig
  {
    uuid: '3c8bf34f-89e8-45f7-a1f4-0c42d662b0d6',
    type: OrderPointType.FERRY,
    from: FERRIES.claonaig,
    to: FERRIES.lochranza,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 9 },
    duration: Duration.fromObject({ minutes: 30 }).as('seconds'),
  },
  // Colintraive
  {
    uuid: 'ad86c792-d147-4a4c-b365-3cc3acb07c40',
    type: OrderPointType.FERRY,
    from: FERRIES.colintraive,
    to: FERRIES.rhubodach,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 5 }).as('seconds'),
  },
  // Kennacraig
  {
    uuid: '7977905c-4000-4631-91ab-586d5571be36',
    type: OrderPointType.FERRY,
    from: FERRIES.kennacraig,
    to: FERRIES.portAskaig,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  {
    uuid: 'd002cc27-1233-4787-93b5-bb69e721539e',
    type: OrderPointType.FERRY,
    from: FERRIES.kennacraig,
    to: FERRIES.portEllen,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  // Kilchoan
  {
    uuid: '4466397d-c29c-4e1e-a172-2e1c94ff7d0f',
    type: OrderPointType.FERRY,
    from: FERRIES.kilchoan,
    to: FERRIES.tobermory,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 35 }).as('seconds'),
  },
  // Lochaline
  {
    uuid: '3cc66859-a3f1-42a9-b4e1-3e49f33b46bd',
    type: OrderPointType.FERRY,
    from: FERRIES.lochaline,
    to: FERRIES.fishnish,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 20 }).as('seconds'),
  },
  // Mallaig
  {
    uuid: '7805e3e6-0afb-44e6-98e6-af2a1d50522f',
    type: OrderPointType.FERRY,
    from: FERRIES.mallaig,
    to: FERRIES.armadale,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 5 },
    duration: Duration.fromObject({ minutes: 45 }).as('seconds'),
  },
  {
    uuid: '1f819e00-8199-4606-9c81-b903f4574543',
    type: OrderPointType.FERRY,
    from: FERRIES.mallaig,
    to: FERRIES.canna,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 3 }).as('seconds'),
  },
  {
    uuid: '7e9337a3-f5f3-4766-983f-1b436a18df6e',
    type: OrderPointType.FERRY,
    from: FERRIES.mallaig,
    to: FERRIES.eigg,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  {
    uuid: 'bfd222ca-86c0-4ae7-b3d8-6309cfef43a5',
    type: OrderPointType.FERRY,
    from: FERRIES.mallaig,
    to: FERRIES.lochboisdale,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 4 }).as('seconds'),
  },
  {
    uuid: 'c95112a4-2dd4-4e40-ac73-fa235ebe1c22',
    type: OrderPointType.FERRY,
    from: FERRIES.mallaig,
    to: FERRIES.muck,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  {
    uuid: '9478c15f-8ab3-4a67-8ee3-cded7f9fbadc',
    type: OrderPointType.FERRY,
    from: FERRIES.mallaig,
    to: FERRIES.rum,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 3 }).as('seconds'),
  },
  // Portavadie
  {
    uuid: 'fab788c6-39e9-45b3-b19c-5f19c6b0afa5',
    type: OrderPointType.FERRY,
    from: FERRIES.portavadie,
    to: FERRIES.tarbertLochFyne,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 11 },
    duration: Duration.fromObject({ minutes: 25 }).as('seconds'),
  },
  // Scrabster
  {
    uuid: 'afe290e2-9170-46af-a68b-8bb3e25b3822',
    type: OrderPointType.FERRY,
    from: FERRIES.scrabster,
    to: FERRIES.stromness,
    operator: TransitOperator.NORTHLINK_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  // Tarbert (Loch Fyne)
  {
    uuid: '7f4ddc3b-ca15-4c57-82f6-d10f9ee6dd35',
    type: OrderPointType.FERRY,
    from: FERRIES.tarbertLochFyne,
    to: FERRIES.portavadie,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 11 },
    duration: Duration.fromObject({ minutes: 25 }).as('seconds'),
  },
  // Tayinloan
  {
    uuid: 'cbd1f69d-1e32-43a2-9fa3-19a75f4aab78',
    type: OrderPointType.FERRY,
    from: FERRIES.tayinloan,
    to: FERRIES.gigha,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 11 },
    duration: Duration.fromObject({ minutes: 20 }).as('seconds'),
  },
  // Ullapool
  {
    uuid: '57de8589-eae8-4280-b7de-3955d98273de',
    type: OrderPointType.FERRY,
    from: FERRIES.ullapool,
    to: FERRIES.stornoway,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 3 }).as('seconds'),
  },
  // Wemyss Bay
  {
    uuid: '42faacbc-b68b-4474-a0ca-7d11b949ec4e',
    type: OrderPointType.FERRY,
    from: FERRIES.wemyssBay,
    to: FERRIES.rothesay,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 35 }).as('seconds'),
  },

  /* Scottish Isles */
  // Armadale
  {
    uuid: '46d2de51-ea32-48ec-87ec-e6e11c82659e',
    type: OrderPointType.FERRY,
    from: FERRIES.armadale,
    to: FERRIES.mallaig,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 5 },
    duration: Duration.fromObject({ minutes: 45 }).as('seconds'),
  },
  // Barra (Ardmhor)
  {
    uuid: '6718c2bc-849d-40be-834e-29792af3e7a6',
    type: OrderPointType.FERRY,
    from: FERRIES.barraArdmhor,
    to: FERRIES.eriskay,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 5 },
    duration: Duration.fromObject({ minutes: 40 }).as('seconds'),
  },
  // Berneray
  {
    uuid: '68bbd23c-a0d1-49b5-b81a-ad45521856bb',
    type: OrderPointType.FERRY,
    from: FERRIES.berneray,
    to: FERRIES.leverburgh,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 4 },
    duration: Duration.fromObject({ hours: 1 }).as('seconds'),
  },
  // Brodick
  {
    uuid: '693d65b7-8b20-45e3-aa35-4146e735c83e',
    type: OrderPointType.FERRY,
    from: FERRIES.brodick,
    to: FERRIES.ardrossan,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 6 },
    duration: Duration.fromObject({ minutes: 55 }).as('seconds'),
  },
  // Canna
  {
    uuid: '8982b348-b986-4f40-96dc-8658e325ed5b',
    type: OrderPointType.FERRY,
    from: FERRIES.canna,
    to: FERRIES.mallaig,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 3 }).as('seconds'),
  },
  // Castlebay
  {
    uuid: 'd81e1b1a-9876-4241-bf55-1b921b68d7b0',
    type: OrderPointType.FERRY,
    from: FERRIES.castlebay,
    to: FERRIES.oban,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 5 }).as('seconds'),
  },
  // Coll
  {
    uuid: 'a26ce4d2-7c75-4810-9b5f-51b3f4811a47',
    type: OrderPointType.FERRY,
    from: FERRIES.coll,
    to: FERRIES.oban,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 3 }).as('seconds'),
  },
  {
    uuid: '63f06d08-091b-4629-a525-367c86291506',
    type: OrderPointType.FERRY,
    from: FERRIES.coll,
    to: FERRIES.tiree,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ minutes: 57 }).as('seconds'),
  },
  // Eigg
  {
    uuid: '9bd95ffc-0e6b-4525-9918-a4a577b64dde',
    type: OrderPointType.FERRY,
    from: FERRIES.eigg,
    to: FERRIES.mallaig,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 3 }).as('seconds'),
  },
  // Eriskay
  {
    uuid: 'f120f1dd-8211-409b-b715-b838191f4627',
    type: OrderPointType.FERRY,
    from: FERRIES.eriskay,
    to: FERRIES.barraArdmhor,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 5 },
    duration: Duration.fromObject({ minutes: 40 }).as('seconds'),
  },
  // Fishnish
  {
    uuid: 'dd6ec72c-a23c-4e12-a09b-1380873ce7aa',
    type: OrderPointType.FERRY,
    from: FERRIES.fishnish,
    to: FERRIES.lochaline,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 20 }).as('seconds'),
  },
  // Gigha
  {
    uuid: 'f033e481-f759-41d8-913c-989854e0f220',
    type: OrderPointType.FERRY,
    from: FERRIES.gigha,
    to: FERRIES.tayinloan,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 11 },
    duration: Duration.fromObject({ minutes: 20 }).as('seconds'),
  },
  // Kirkwall
  {
    uuid: 'c81dff35-4b69-4bd4-990f-529194f52c79',
    type: OrderPointType.FERRY,
    from: FERRIES.kirkwall,
    to: FERRIES.aberdeen,
    operator: TransitOperator.NORTHLINK_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 4 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  {
    uuid: '261c4fc8-a019-4925-90d7-17e40751bda5',
    type: OrderPointType.FERRY,
    from: FERRIES.kirkwall,
    to: FERRIES.lerwick,
    operator: TransitOperator.NORTHLINK_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 7 }).as('seconds'),
  },
  // Lerwick
  {
    uuid: '4f71eccc-2a5a-4cbd-9bc7-aca556458cce',
    type: OrderPointType.FERRY,
    from: FERRIES.lerwick,
    to: FERRIES.aberdeen,
    operator: TransitOperator.NORTHLINK_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 15 }).as('seconds'),
  },
  {
    uuid: '71b75e34-0aac-48f6-87db-586cf7127cad',
    type: OrderPointType.FERRY,
    from: FERRIES.lerwick,
    to: FERRIES.kirkwall,
    operator: TransitOperator.NORTHLINK_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 6 }).as('seconds'),
  },
  // Leverburgh
  {
    uuid: '4a3c6326-5803-4a84-8a6e-f30d10ef9f78',
    type: OrderPointType.FERRY,
    from: FERRIES.leverburgh,
    to: FERRIES.berneray,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 4 },
    duration: Duration.fromObject({ hours: 1 }).as('seconds'),
  },
  // Lismore
  {
    uuid: '7de1562a-2e86-4f2b-9894-51dd0c61b954',
    type: OrderPointType.FERRY,
    from: FERRIES.lismore,
    to: FERRIES.oban,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 4 },
    duration: Duration.fromObject({ minutes: 55 }).as('seconds'),
  },
  // Lochboisdale
  {
    uuid: '54c005c9-aa85-4852-b5f2-8abadb6fe6b0',
    type: OrderPointType.FERRY,
    from: FERRIES.lochboisdale,
    to: FERRIES.mallaig,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 4 }).as('seconds'),
  },
  // Lochmaddy
  {
    uuid: '45fd0fa7-31d8-4ad8-9597-f19629498997',
    type: OrderPointType.FERRY,
    from: FERRIES.lochmaddy,
    to: FERRIES.uig,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  // Lochranza
  {
    uuid: 'f8404e58-cc0a-46ce-a9dc-bed2dda57b88',
    type: OrderPointType.FERRY,
    from: FERRIES.lochranza,
    to: FERRIES.claonaig,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 9 },
    duration: Duration.fromObject({ minutes: 30 }).as('seconds'),
  },
  // Muck
  {
    uuid: 'd4fd8e78-cd1d-4c16-8c14-30d144d82f3b',
    type: OrderPointType.FERRY,
    from: FERRIES.muck,
    to: FERRIES.mallaig,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 3 }).as('seconds'),
  },
  // Oban
  {
    uuid: 'e352fa88-0ffa-4209-90b6-11bbc12be3ec',
    type: OrderPointType.FERRY,
    from: FERRIES.oban,
    to: FERRIES.castlebay,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 5 }).as('seconds'),
  },
  {
    uuid: '8ecc6417-4150-43ba-a975-19f12afde068',
    type: OrderPointType.FERRY,
    from: FERRIES.oban,
    to: FERRIES.coll,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 3 }).as('seconds'),
  },
  {
    uuid: 'e2a36188-9a0d-4bff-8bb0-a6865271d92e',
    type: OrderPointType.FERRY,
    from: FERRIES.oban,
    to: FERRIES.lismore,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 4 },
    duration: Duration.fromObject({ minutes: 55 }).as('seconds'),
  },
  // Port Askaig
  {
    uuid: 'af84b7e3-e3cf-4f40-926f-5cdf291a466d',
    type: OrderPointType.FERRY,
    from: FERRIES.portAskaig,
    to: FERRIES.kennacraig,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 3 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  // Port Ellen
  {
    uuid: '81ab93d3-f3fa-4f3a-ab77-468003562c40',
    type: OrderPointType.FERRY,
    from: FERRIES.portEllen,
    to: FERRIES.kennacraig,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  // Raasay
  {
    uuid: 'eed57946-10f6-4fba-9c7f-78fffb31d403',
    type: OrderPointType.FERRY,
    from: FERRIES.raasay,
    to: FERRIES.sconser,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 11 },
    duration: Duration.fromObject({ minutes: 25 }).as('seconds'),
  },
  // Rhubodach
  {
    uuid: '748b1574-2f4d-4308-8d25-36cd80f57753',
    type: OrderPointType.FERRY,
    from: FERRIES.rhubodach,
    to: FERRIES.colintraive,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 5 }).as('seconds'),
  },
  // Rothesay
  {
    uuid: '7ae28c5e-db33-4611-a52f-e90d50989d76',
    type: OrderPointType.FERRY,
    from: FERRIES.rothesay,
    to: FERRIES.wemyssBay,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 35 }).as('seconds'),
  },
  // Rum
  {
    uuid: '48cfc1ea-ac7e-4ff3-9590-8b7c59caffd5',
    type: OrderPointType.FERRY,
    from: FERRIES.rum,
    to: FERRIES.mallaig,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  // Sconser
  {
    uuid: 'bd02b78f-2757-4f20-b190-977b7dcd2020',
    type: OrderPointType.FERRY,
    from: FERRIES.sconser,
    to: FERRIES.raasay,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 11 },
    duration: Duration.fromObject({ minutes: 25 }).as('seconds'),
  },
  // Stornoway
  {
    uuid: 'f18eebc3-4301-4c89-8461-4d1de8a51e3e',
    type: OrderPointType.FERRY,
    from: FERRIES.stornoway,
    to: FERRIES.ullapool,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 3 },
    duration: Duration.fromObject({ hours: 3 }).as('seconds'),
  },
  // Stromness
  {
    uuid: '15ddff82-54ea-41b5-9f72-6bf9f303e850',
    type: OrderPointType.FERRY,
    from: FERRIES.stromness,
    to: FERRIES.scrabster,
    operator: TransitOperator.NORTHLINK_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  // Tarbert (Harris)
  {
    uuid: 'd3fc6c66-27c2-49cf-bf64-9d28ab2c072b',
    type: OrderPointType.FERRY,
    from: FERRIES.tarbertHarris,
    to: FERRIES.uig,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  // Tiree
  {
    uuid: '67076c4e-9322-4a55-a437-ea2efe058f32',
    type: OrderPointType.FERRY,
    from: FERRIES.tiree,
    to: FERRIES.coll,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ minutes: 55 }).as('seconds'),
  },
  // Tobermory
  {
    uuid: 'f318c0f8-5e5c-4f45-88ef-94baa2d18f85',
    type: OrderPointType.FERRY,
    from: FERRIES.tobermory,
    to: FERRIES.kilchoan,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 35 }).as('seconds'),
  },
  // Uig
  {
    uuid: 'a04698c2-e769-40a1-b7f7-ace867f2923e',
    type: OrderPointType.FERRY,
    from: FERRIES.uig,
    to: FERRIES.lochmaddy,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  {
    uuid: '2bdc87f5-b630-4bd6-a5ac-295b73cb4efb',
    type: OrderPointType.FERRY,
    from: FERRIES.uig,
    to: FERRIES.tarbertHarris,
    operator: TransitOperator.CALEDONIAN_MACBRAYNE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },

  /* Sicily */
  // Catania
  {
    uuid: '8b9a8bbb-f139-42b4-a0c4-2f5e2c6fcdf0',
    type: OrderPointType.FERRY,
    from: FERRIES.catania,
    to: FERRIES.brindisi,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 18 }).as('seconds'),
  },
  {
    uuid: '89769093-7b9c-4cdb-afb8-0ea76887ca27',
    type: OrderPointType.FERRY,
    from: FERRIES.catania,
    to: FERRIES.genoa,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 35 }).as('seconds'),
  },
  {
    uuid: 'cea7271f-2c14-4ca0-a233-3bc3d6724475',
    type: OrderPointType.FERRY,
    from: FERRIES.catania,
    to: FERRIES.livorno,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 4 },
    duration: Duration.fromObject({ hours: 36 }).as('seconds'),
  },
  {
    uuid: 'bdd21b95-d74b-4cb7-b756-e2894ee780bc',
    type: OrderPointType.FERRY,
    from: FERRIES.catania,
    to: FERRIES.ravenna,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 48 }).as('seconds'),
  },
  {
    uuid: '6e10b552-74f7-4ed3-8b3d-5fab44dd5d2b',
    type: OrderPointType.FERRY,
    from: FERRIES.catania,
    to: FERRIES.sagunto,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 72 }).as('seconds'),
  },
  {
    uuid: '1310e7d8-fb5e-4cfd-80eb-d9c467924777',
    type: OrderPointType.FERRY,
    from: FERRIES.catania,
    to: FERRIES.salerno,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 13 }).as('seconds'),
  },
  {
    uuid: '50826504-9ebe-4bc9-a158-a43104aa68c9',
    type: OrderPointType.FERRY,
    from: FERRIES.catania,
    to: FERRIES.valencia,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 4 },
    duration: Duration.fromObject({ hours: 107 }).as('seconds'),
  },
  // Palermo
  {
    uuid: '081a41f1-54be-4a6e-b7ca-6b16ebbdc7b1',
    type: OrderPointType.FERRY,
    from: FERRIES.palermo,
    to: FERRIES.cagliari,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 12 }).as('seconds'),
  },
  {
    uuid: '088c697f-86d9-4d59-a3a0-6b21bca51798',
    type: OrderPointType.FERRY,
    from: FERRIES.palermo,
    to: FERRIES.civitavecchia,
    operator: TransitOperator.GRANDI_NAVI_VELOCI,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 14 }).as('seconds'),
  },
  {
    uuid: '36520485-f630-45e3-bc41-b7e64ba39e3c',
    type: OrderPointType.FERRY,
    from: FERRIES.palermo,
    to: FERRIES.genoa,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 4 },
    duration: Duration.fromObject({ hours: 37 }).as('seconds'),
  },
  {
    uuid: '4d8fb4d8-6f11-4a1a-8d5e-30763a56faa5',
    type: OrderPointType.FERRY,
    from: FERRIES.palermo,
    to: FERRIES.livorno,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 22 }).as('seconds'),
  },
  {
    uuid: '3a493734-78a7-44ff-bce9-08559274855f',
    type: OrderPointType.FERRY,
    from: FERRIES.palermo,
    to: FERRIES.naples,
    operator: TransitOperator.TIRRENIA_LINES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 11 }).as('seconds'),
  },
  {
    uuid: 'a3247455-4888-4559-9bde-c7f6e481366f',
    type: OrderPointType.FERRY,
    from: FERRIES.palermo,
    to: FERRIES.sagunto,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 7 },
    duration: Duration.fromObject({ hours: 78 }).as('seconds'),
  },
  {
    uuid: '35301434-d5e5-4b51-a664-d74a275e645a',
    type: OrderPointType.FERRY,
    from: FERRIES.palermo,
    to: FERRIES.salerno,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 12 }).as('seconds'),
  },
  // Termini Imerese
  {
    uuid: '4761c9d7-8a32-4c85-9695-9c3cec6f4bfc',
    type: OrderPointType.FERRY,
    from: FERRIES.terminiImerese,
    to: FERRIES.civitavecchia,
    operator: TransitOperator.GRANDI_NAVI_VELOCI,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 14 }).as('seconds'),
  },
  {
    uuid: 'fddf4404-0a75-470e-9e4f-9dfbb00e1e9f',
    type: OrderPointType.FERRY,
    from: FERRIES.terminiImerese,
    to: FERRIES.genoa,
    operator: TransitOperator.GRANDI_NAVI_VELOCI,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 21 }).as('seconds'),
  },
  {
    uuid: '65d58752-31cf-4cb4-90c6-690ac22f65da',
    type: OrderPointType.FERRY,
    from: FERRIES.terminiImerese,
    to: FERRIES.naples,
    operator: TransitOperator.GRANDI_NAVI_VELOCI,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 10 }).as('seconds'),
  },
  // Tremestieri
  {
    uuid: '8c782dab-b7cd-43ce-93da-6064213cc4fb',
    type: OrderPointType.FERRY,
    from: FERRIES.tremestieri,
    to: FERRIES.villaSanGiovanni,
    operator: TransitOperator.BLUFERRIES,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ hours: 1 }).as('seconds'),
  },

  /* Spain */
  // Algeciras
  {
    uuid: '1dbf959b-2df0-468a-8283-5e047bfb41f0',
    type: OrderPointType.FERRY,
    from: FERRIES.algeciras,
    to: FERRIES.ceuta,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 5 },
    duration: Duration.fromObject({ hours: 1 }).as('seconds'),
  },
  // Unsupported destination country
  // {
  //   uuid: '99f48d86-0df7-4eb7-89c0-c4c3c73ed34d',
  //   type: OrderPointType.FERRY,
  //   from: FERRIES.algeciras,
  //   to: FERRIES.tangerMed,
  //   operator: TransitOperator.AFRICA_MOROCCO_LINK,
  //   frequency: { interval: TransitFrequencyInterval.DAY, value: 9 },
  //   duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  // },
  // Almeria
  // Unsupported destination country
  // {
  //   uuid: '424cad9b-06c1-4648-b5cb-5ce8a5088855',
  //   type: OrderPointType.FERRY,
  //   from: FERRIES.almeria,
  //   to: FERRIES.ghazaouet,
  //   operator: TransitOperator.NAVIERA_ARMAS,
  //   frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
  //   duration: Duration.fromObject({ hours: 8 }).as('seconds'),
  // },
  // Unsupported destination country
  // {
  //   uuid: 'ba6391ab-712d-4ddb-bfeb-005dddc09b2c',
  //   type: OrderPointType.FERRY,
  //   from: FERRIES.almeria,
  //   to: FERRIES.melilla,
  //   operator: TransitOperator.NAVIERA_ARMAS,
  //   frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
  //   duration: Duration.fromObject({ hours: 7 }).as('seconds'),
  // },
  // Unsupported destination country
  // {
  //   uuid: 'c9a504c5-35e8-42f8-9403-0183a97b0db0',
  //   type: OrderPointType.FERRY,
  //   from: FERRIES.almeria,
  //   to: FERRIES.nador,
  //   operator: TransitOperator.NAVIERA_ARMAS,
  //   frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
  //   duration: Duration.fromObject({ hours: 11 }).as('seconds'),
  // },
  // Barcelona
  {
    uuid: '7ad25a49-1850-4c15-9007-94b79470b45b',
    type: OrderPointType.FERRY,
    from: FERRIES.barcelona,
    to: FERRIES.alcudia,
    operator: TransitOperator.BALEARIA,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 5 }).as('seconds'),
  },
  {
    uuid: '42e08ec5-cdb4-4672-bbc4-283a9dfd73ff',
    type: OrderPointType.FERRY,
    from: FERRIES.barcelona,
    to: FERRIES.ciutadella,
    operator: TransitOperator.BALEARIA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 9 },
    duration: Duration.fromObject({ hours: 8 }).as('seconds'),
  },
  {
    uuid: '55da3fab-1bf2-4904-9243-415a890a1a62',
    type: OrderPointType.FERRY,
    from: FERRIES.barcelona,
    to: FERRIES.civitavecchia,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 23 }).as('seconds'),
  },
  {
    uuid: '812e7dab-c0c4-4152-ad1f-e898f65d3d85',
    type: OrderPointType.FERRY,
    from: FERRIES.barcelona,
    to: FERRIES.genoa,
    operator: TransitOperator.GRANDI_NAVI_VELOCI,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 23 }).as('seconds'),
  },
  {
    uuid: '54242a6c-c283-47ee-9c68-61c3e43cdea2',
    type: OrderPointType.FERRY,
    from: FERRIES.barcelona,
    to: FERRIES.ibiza,
    operator: TransitOperator.GRANDI_NAVI_VELOCI,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 10 }).as('seconds'),
  },
  {
    uuid: 'd770f747-38b3-47d3-a279-e1bcfec2efea',
    type: OrderPointType.FERRY,
    from: FERRIES.barcelona,
    to: FERRIES.igoumenitsa,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 48 }).as('seconds'),
  },
  {
    uuid: 'd9401261-eeb9-4391-a3c4-37460fee9c30',
    type: OrderPointType.FERRY,
    from: FERRIES.barcelona,
    to: FERRIES.livorno,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 29 }).as('seconds'),
  },
  {
    uuid: '4110fa2f-db2f-4ceb-afe3-58c5e8e65512',
    type: OrderPointType.FERRY,
    from: FERRIES.barcelona,
    to: FERRIES.mahon,
    operator: TransitOperator.GRANDI_NAVI_VELOCI,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  {
    uuid: '0e920f5c-63e8-47e1-8882-87dd5bb0101b',
    type: OrderPointType.FERRY,
    from: FERRIES.barcelona,
    to: FERRIES.palmaMallorca,
    operator: TransitOperator.BALEARIA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 7 }).as('seconds'),
  },
  {
    uuid: 'fe1f8942-fd6b-409b-b009-c4135292926f',
    type: OrderPointType.FERRY,
    from: FERRIES.barcelona,
    to: FERRIES.portoTorres,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 15 }).as('seconds'),
  },
  {
    uuid: '7b5ee49a-ce48-45da-9897-ec332adf7eda',
    type: OrderPointType.FERRY,
    from: FERRIES.barcelona,
    to: FERRIES.savona,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 25 }).as('seconds'),
  },
  // Unsupported destination country
  // {
  //   uuid: '3eb47a3c-943b-4f73-bf69-0e042cd4239e',
  //   type: OrderPointType.FERRY,
  //   from: FERRIES.barcelona,
  //   to: FERRIES.tangerMed,
  //   operator: TransitOperator.GRANDI_NAVI_VELOCI,
  //   frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
  //   duration: Duration.fromObject({ hours: 8 }).as('seconds'),
  // },
  // Bilbao
  {
    uuid: '8cb86e53-f605-4eec-888e-f8c797d4c7f2',
    type: OrderPointType.FERRY,
    from: FERRIES.bilbao,
    to: FERRIES.portsmouth,
    operator: TransitOperator.BRITTANY_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 31 }).as('seconds'),
  },
  {
    uuid: '7832c35b-c8bd-44bd-a08c-25c0900dd2b9',
    type: OrderPointType.FERRY,
    from: FERRIES.bilbao,
    to: FERRIES.rosslare,
    operator: TransitOperator.BRITTANY_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 28 }).as('seconds'),
  },
  // Cadiz
  {
    uuid: '249d742d-8f2b-4393-bceb-3625b5d67f51',
    type: OrderPointType.FERRY,
    from: FERRIES.cadiz,
    to: FERRIES.arrecife,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 28 }).as('seconds'),
  },
  {
    uuid: '1799e0fd-d1e8-4b47-aa82-d54e26fee84e',
    type: OrderPointType.FERRY,
    from: FERRIES.cadiz,
    to: FERRIES.lasPalmasGranCanaria,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 34 }).as('seconds'),
  },
  {
    uuid: '2478ac91-232d-4e0f-bcf4-e8615aa34043',
    type: OrderPointType.FERRY,
    from: FERRIES.cadiz,
    to: FERRIES.puertoRosario,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 29 }).as('seconds'),
  },
  {
    uuid: 'ee1cc1d2-9053-4e94-82c3-d84a64ff9a1b',
    type: OrderPointType.FERRY,
    from: FERRIES.cadiz,
    to: FERRIES.santaCruzDeLaPalma,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 56 }).as('seconds'),
  },
  {
    uuid: 'b1d99bb8-414d-4adc-9927-c0b04c0a3791',
    type: OrderPointType.FERRY,
    from: FERRIES.cadiz,
    to: FERRIES.santaCruzDeTenerife,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 41 }).as('seconds'),
  },
  // Ceuta
  {
    uuid: '0c586346-0400-485f-86f4-a8a8f31cb12d',
    type: OrderPointType.FERRY,
    from: FERRIES.ceuta,
    to: FERRIES.algeciras,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 5 },
    duration: Duration.fromObject({ hours: 1 }).as('seconds'),
  },
  // Denia
  {
    uuid: 'a3cfac40-80b0-446c-8d90-c9b4e57e1820',
    type: OrderPointType.FERRY,
    from: FERRIES.denia,
    to: FERRIES.ibiza,
    operator: TransitOperator.BALEARIA,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  {
    uuid: '16b9995e-b017-47a6-9ef4-36fd6f4ad3be',
    type: OrderPointType.FERRY,
    from: FERRIES.denia,
    to: FERRIES.palmaMallorca,
    operator: TransitOperator.BALEARIA,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 5 }).as('seconds'),
  },
  // Huelva
  {
    uuid: '4ad74a7f-7fa2-4e92-a392-ecc2d6396e28',
    type: OrderPointType.FERRY,
    from: FERRIES.huelva,
    to: FERRIES.arrecife,
    operator: TransitOperator.BALEARIA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 46 }).as('seconds'),
  },
  {
    uuid: 'd96bc93d-fb03-48cc-92a0-92ea41cf69de',
    type: OrderPointType.FERRY,
    from: FERRIES.huelva,
    to: FERRIES.lasPalmasGranCanaria,
    operator: TransitOperator.NAVIERA_ARMAS,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 32 }).as('seconds'),
  },
  {
    uuid: '5b6183d9-25a3-48e7-8608-b6ef33168a43',
    type: OrderPointType.FERRY,
    from: FERRIES.huelva,
    to: FERRIES.santaCruzDeTenerife,
    operator: TransitOperator.BALEARIA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 37 }).as('seconds'),
  },
  // Malaga
  // Unsupported destination country
  // {
  //   uuid: '7d3edc63-b7f3-4fd7-9838-341083f25d86',
  //   type: OrderPointType.FERRY,
  //   from: FERRIES.malaga,
  //   to: FERRIES.melilla,
  //   operator: TransitOperator.BALEARIA,
  //   frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
  //   duration: Duration.fromObject({ hours: 6 }).as('seconds'),
  // },
  // Motril
  // Unsupported destination country
  // {
  //   uuid: 'b7e98e29-8f82-4743-a8fc-2f5f7a1d4f7d',
  //   type: OrderPointType.FERRY,
  //   from: FERRIES.motril,
  //   to: FERRIES.tangerMed,
  //   operator: TransitOperator.BALEARIA,
  //   frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
  //   duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  // },
  // Sagunto
  {
    uuid: '60c31b8f-ec2d-4ece-b731-3c659c7e7aa2',
    type: OrderPointType.FERRY,
    from: FERRIES.sagunto,
    to: FERRIES.cagliari,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 53 }).as('seconds'),
  },
  {
    uuid: 'e4c7ace3-f092-4801-a119-79b078eb0931',
    type: OrderPointType.FERRY,
    from: FERRIES.sagunto,
    to: FERRIES.catania,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 77 }).as('seconds'),
  },
  {
    uuid: '062a44aa-d918-474a-8de0-742ddccb9b84',
    type: OrderPointType.FERRY,
    from: FERRIES.sagunto,
    to: FERRIES.palermo,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 3 },
    duration: Duration.fromObject({ hours: 77 }).as('seconds'),
  },
  {
    uuid: 'c3aa0ddb-a529-4cae-9360-2eeecfc74b1b',
    type: OrderPointType.FERRY,
    from: FERRIES.sagunto,
    to: FERRIES.palmaMallorca,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 11 }).as('seconds'),
  },
  {
    uuid: '37b9e29a-63c3-49f0-a229-08548eb8507a',
    type: OrderPointType.FERRY,
    from: FERRIES.sagunto,
    to: FERRIES.salerno,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 52 }).as('seconds'),
  },
  // Santander
  {
    uuid: '24768684-8fdc-43a2-ac64-7aac6c27e587',
    type: OrderPointType.FERRY,
    from: FERRIES.santander,
    to: FERRIES.plymouth,
    operator: TransitOperator.BRITTANY_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 21 }).as('seconds'),
  },
  {
    uuid: '6031d504-8de0-4f0e-944b-61ca17e8bb3d',
    type: OrderPointType.FERRY,
    from: FERRIES.santander,
    to: FERRIES.portsmouth,
    operator: TransitOperator.BRITTANY_FERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 30 }).as('seconds'),
  },
  // Valencia
  {
    uuid: 'fd923871-d3c0-44f4-9ce6-9c66ee3b86b0',
    type: OrderPointType.FERRY,
    from: FERRIES.valencia,
    to: FERRIES.catania,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 4 },
    duration: Duration.fromObject({ hours: 81 }).as('seconds'),
  },
  {
    uuid: '43f37199-cca2-4a3f-98bd-df2232d69251',
    type: OrderPointType.FERRY,
    from: FERRIES.valencia,
    to: FERRIES.ibiza,
    operator: TransitOperator.TRANSMED_GLE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 6 }).as('seconds'),
  },
  {
    uuid: '12c75c3e-a66f-47fb-b37d-9a0c1ef2f8de',
    type: OrderPointType.FERRY,
    from: FERRIES.valencia,
    to: FERRIES.livorno,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 51 }).as('seconds'),
  },
  {
    uuid: '6d784725-b984-4ea9-b50c-4a6b74145057',
    type: OrderPointType.FERRY,
    from: FERRIES.valencia,
    to: FERRIES.mahon,
    operator: TransitOperator.TRANSMED_GLE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 16 }).as('seconds'),
  },
  {
    uuid: '31569f14-4895-43ca-8508-504799101bd6',
    type: OrderPointType.FERRY,
    from: FERRIES.valencia,
    to: FERRIES.palmaMallorca,
    operator: TransitOperator.TRANSMED_GLE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 8 }).as('seconds'),
  },
  {
    uuid: '3b0fa40f-bfe2-4724-90f1-8d1a98a1db1f',
    type: OrderPointType.FERRY,
    from: FERRIES.valencia,
    to: FERRIES.savona,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 43 }).as('seconds'),
  },

  /* Sweden */
  // Gothenburg
  {
    uuid: 'da9d588c-a5c3-4c58-9f1f-c47f751b1b89',
    type: OrderPointType.FERRY,
    from: FERRIES.gothenburg,
    to: FERRIES.brevik,
    operator: TransitOperator.DFDS_SEAWAYS_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 7 }).as('seconds'),
  },
  {
    uuid: 'ef87718c-2f1c-440d-bc02-cc31e9610bab',
    type: OrderPointType.FERRY,
    from: FERRIES.gothenburg,
    to: FERRIES.frederikshavn,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 4 },
    duration: Duration.fromObject({ hours: 4 }).as('seconds'),
  },
  {
    uuid: '00ee520a-b633-4aef-b581-dec4e4da3f16',
    type: OrderPointType.FERRY,
    from: FERRIES.gothenburg,
    to: FERRIES.ghent,
    operator: TransitOperator.DFDS_SEAWAYS_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 5 },
    duration: Duration.fromObject({ hours: 32 }).as('seconds'),
  },
  {
    uuid: '39f52691-3397-4cd0-85d8-8d6cbdf16909',
    type: OrderPointType.FERRY,
    from: FERRIES.gothenburg,
    to: FERRIES.immingham,
    operator: TransitOperator.DFDS_SEAWAYS_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 7 },
    duration: Duration.fromObject({ hours: 30 }).as('seconds'),
  },
  {
    uuid: 'a4444de2-ac6f-433b-aa3b-db8a5df1fc92',
    type: OrderPointType.FERRY,
    from: FERRIES.gothenburg,
    to: FERRIES.kiel,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 15 }).as('seconds'),
  },
  {
    uuid: '563b87ea-fa17-4ccc-bafe-baf2586092bb',
    type: OrderPointType.FERRY,
    from: FERRIES.gothenburg,
    to: FERRIES.zeebrugge,
    operator: TransitOperator.DFDS_SEAWAYS_NORTH_SEA,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 4 },
    duration: Duration.fromObject({ hours: 34 }).as('seconds'),
  },
  // Halmstad
  {
    uuid: '0ef8fc44-2259-4479-828f-90279563781c',
    type: OrderPointType.FERRY,
    from: FERRIES.halmstad,
    to: FERRIES.grenaa,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 10 },
    duration: Duration.fromObject({ hours: 5 }).as('seconds'),
  },
  // Helsingborg
  {
    uuid: 'fc3117ed-5ffe-4c1c-bc0d-476ae4bd77b7',
    type: OrderPointType.FERRY,
    from: FERRIES.helsingborg,
    to: FERRIES.helsingor,
    operator: TransitOperator.SCANDLINES,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 20 }).as('seconds'),
  },
  {
    uuid: 'f3bb1006-9fc1-4e61-b062-66f44858ec00',
    type: OrderPointType.FERRY,
    from: FERRIES.helsingborg,
    to: FERRIES.puttgarden,
    operator: TransitOperator.SCANDLINES,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ hours: 1 }).as('seconds'),
  },
  {
    uuid: '1dc4d161-52b1-4e51-b0ce-8ca552b990d2',
    type: OrderPointType.FERRY,
    from: FERRIES.helsingborg,
    to: FERRIES.rostock,
    operator: TransitOperator.SCANDLINES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 10 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  // Karlshamn
  {
    uuid: '13296c6a-c73f-4a89-b804-6e858851839a',
    type: OrderPointType.FERRY,
    from: FERRIES.karlshamn,
    to: FERRIES.klaipeda,
    operator: TransitOperator.DFDS_SEAWAYS_BALTIC_SEA,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 14 }).as('seconds'),
  },
  {
    uuid: 'd4d88626-fed9-48ed-89ac-9a70f4e387bf',
    type: OrderPointType.FERRY,
    from: FERRIES.karlshamn,
    to: FERRIES.rostock,
    operator: TransitOperator.TT_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 14 }).as('seconds'),
  },
  {
    uuid: '06859021-4aa6-4156-8ea9-02a3e45bcdae',
    type: OrderPointType.FERRY,
    from: FERRIES.karlshamn,
    to: FERRIES.travemunde,
    operator: TransitOperator.TT_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 17 }).as('seconds'),
  },
  {
    uuid: '0750ec75-7933-4ab3-ae10-4e0e905430b2',
    type: OrderPointType.FERRY,
    from: FERRIES.karlshamn,
    to: FERRIES.trelleborg,
    operator: TransitOperator.TT_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 6 }).as('seconds'),
  },
  // Karlskrona
  {
    uuid: '7f8cc5ff-6f49-4823-8551-be9910dd8324',
    type: OrderPointType.FERRY,
    from: FERRIES.karlskrona,
    to: FERRIES.gdynia,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 3 },
    duration: Duration.fromObject({ hours: 11 }).as('seconds'),
  },
  // Malmo
  {
    uuid: '6cd477f8-47f7-46c4-9560-f1ce07fc871c',
    type: OrderPointType.FERRY,
    from: FERRIES.malmo,
    to: FERRIES.puttgarden,
    operator: TransitOperator.SCANDLINES,
    frequency: { interval: TransitFrequencyInterval.MANY, value: null },
    duration: Duration.fromObject({ minutes: 45 }).as('seconds'),
  },
  {
    uuid: '33c57502-f4bf-4923-a8d1-02da67105810',
    type: OrderPointType.FERRY,
    from: FERRIES.malmo,
    to: FERRIES.rostock,
    operator: TransitOperator.SCANDLINES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 10 },
    duration: Duration.fromObject({ hours: 2 }).as('seconds'),
  },
  {
    uuid: 'd23419a7-b670-49d3-8eb6-c20443b409a7',
    type: OrderPointType.FERRY,
    from: FERRIES.malmo,
    to: FERRIES.swinoujscie,
    operator: TransitOperator.NORDOLINK,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  {
    uuid: '4046f7c4-f862-4343-aa09-24d06a03dcad',
    type: OrderPointType.FERRY,
    from: FERRIES.malmo,
    to: FERRIES.travemunde,
    operator: TransitOperator.NORDOLINK,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 3 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  // Nynashamn
  {
    uuid: '8b8518e8-b3d3-42da-a92e-42b0807a84d9',
    type: OrderPointType.FERRY,
    from: FERRIES.nynashamn,
    to: FERRIES.gdansk,
    operator: TransitOperator.POLFERRIES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 18 }).as('seconds'),
  },
  {
    uuid: '4e9be0da-9fc4-47de-9a1b-9efbcc8d0766',
    type: OrderPointType.FERRY,
    from: FERRIES.nynashamn,
    to: FERRIES.ventspils,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  {
    uuid: 'c54d0b48-9db5-4a9c-98b9-0b6e702664fe',
    type: OrderPointType.FERRY,
    from: FERRIES.nynashamn,
    to: FERRIES.visby,
    operator: TransitOperator.DESTINATION_GOTLAND,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 3 }).as('seconds'),
  },
  // Oskarshamn
  {
    uuid: '8f8d3bec-6dd3-4350-ac71-865f50319e49',
    type: OrderPointType.FERRY,
    from: FERRIES.oskarshamn,
    to: FERRIES.visby,
    operator: TransitOperator.DESTINATION_GOTLAND,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 3 }).as('seconds'),
  },
  // Stockholm
  {
    uuid: 'b04e3713-107c-4965-9bbc-f1055a8d110d',
    type: OrderPointType.FERRY,
    from: FERRIES.stockholm,
    to: FERRIES.helsinki,
    operator: TransitOperator.VIKING_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 17 }).as('seconds'),
  },
  {
    uuid: 'c4a58f55-23c2-45e8-86b2-564f101b1979',
    type: OrderPointType.FERRY,
    from: FERRIES.stockholm,
    to: FERRIES.langnas,
    operator: TransitOperator.VIKING_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 7 }).as('seconds'),
  },
  {
    uuid: 'c03cd7bc-911b-4e6c-9683-97da0b26b261',
    type: OrderPointType.FERRY,
    from: FERRIES.stockholm,
    to: FERRIES.mariehamn,
    operator: TransitOperator.VIKING_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 6 }).as('seconds'),
  },
  {
    uuid: 'd4e1a73c-4e19-4b2d-8e35-ccce526a5622',
    type: OrderPointType.FERRY,
    from: FERRIES.stockholm,
    to: FERRIES.turku,
    operator: TransitOperator.VIKING_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 11 }).as('seconds'),
  },
  // Stromstad
  {
    uuid: '767c06b0-6331-4225-a6e7-d7b2b2664a9f',
    type: OrderPointType.FERRY,
    from: FERRIES.stromstad,
    to: FERRIES.sandefjord,
    operator: TransitOperator.COLOR_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 3 }).as('seconds'),
  },
  // Trelleborg
  {
    uuid: 'f0c53517-635c-4999-97d7-a3ed80c8775b',
    type: OrderPointType.FERRY,
    from: FERRIES.trelleborg,
    to: FERRIES.karlshamn,
    operator: TransitOperator.TT_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 7 }).as('seconds'),
  },
  {
    uuid: '11e4d1c6-c828-43e6-89ed-672f720946e9',
    type: OrderPointType.FERRY,
    from: FERRIES.trelleborg,
    to: FERRIES.klaipeda,
    operator: TransitOperator.TT_LINE,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 22 }).as('seconds'),
  },
  {
    uuid: '03af8e8f-9b5a-4a13-b7df-81813edbe755',
    type: OrderPointType.FERRY,
    from: FERRIES.trelleborg,
    to: FERRIES.rostock,
    operator: TransitOperator.TT_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 3 },
    duration: Duration.fromObject({ hours: 7 }).as('seconds'),
  },
  {
    uuid: 'd3a30a58-6ccb-46fe-b828-cbf1d93a3917',
    type: OrderPointType.FERRY,
    from: FERRIES.trelleborg,
    to: FERRIES.swinoujscie,
    operator: TransitOperator.UNITY_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 3 },
    duration: Duration.fromObject({ hours: 7 }).as('seconds'),
  },
  {
    uuid: 'ef8a1ce3-b020-4413-8d9b-74a04daa870c',
    type: OrderPointType.FERRY,
    from: FERRIES.trelleborg,
    to: FERRIES.travemunde,
    operator: TransitOperator.TT_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 4 },
    duration: Duration.fromObject({ hours: 9 }).as('seconds'),
  },
  // Umea
  {
    uuid: 'aedc6434-adc7-4f56-b0f1-a3b4782ea2d2',
    type: OrderPointType.FERRY,
    from: FERRIES.umea,
    to: FERRIES.vaasa,
    operator: TransitOperator.WASALINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 3 },
    duration: Duration.fromObject({ hours: 4 }).as('seconds'),
  },
  // Visby
  {
    uuid: '8db7f79a-d3c6-4b10-b100-476722d6db8c',
    type: OrderPointType.FERRY,
    from: FERRIES.visby,
    to: FERRIES.nynashamn,
    operator: TransitOperator.DESTINATION_GOTLAND,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 3 }).as('seconds'),
  },
  {
    uuid: '9a480944-6893-436f-80fd-4edc88d52110',
    type: OrderPointType.FERRY,
    from: FERRIES.visby,
    to: FERRIES.oskarshamn,
    operator: TransitOperator.DESTINATION_GOTLAND,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 6 },
    duration: Duration.fromObject({ hours: 3 }).as('seconds'),
  },
  // Ystad
  {
    uuid: 'f504b4ed-31ff-4dfd-bd70-1d885bd78769',
    type: OrderPointType.FERRY,
    from: FERRIES.ystad,
    to: FERRIES.ronne,
    operator: TransitOperator.BORNHOLMSLINJEN,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 5 },
    duration: Duration.fromObject({ hours: 1 }).as('seconds'),
  },
  {
    uuid: '1f1cfaf3-585e-43cd-8ec4-e601d3f4e0bf',
    type: OrderPointType.FERRY,
    from: FERRIES.ystad,
    to: FERRIES.swinoujscie,
    operator: TransitOperator.UNITY_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 3 },
    duration: Duration.fromObject({ hours: 7 }).as('seconds'),
  },

  /* Tunisia */
  // TODO: Currently unsupported country (outside of Europe)

  /* Turkey */
  // Alsancak
  {
    uuid: '3d14b905-9608-4f0d-bd7f-d9495d718869',
    type: OrderPointType.FERRY,
    from: FERRIES.alsancak,
    to: FERRIES.sete,
    operator: TransitOperator.DFDS_SEAWAYS_MEDITERRANEAN,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 71 }).as('seconds'),
  },
  // Ambarli
  {
    uuid: 'e50f5e12-d839-4cf2-bda5-a730f68a0971',
    type: OrderPointType.FERRY,
    from: FERRIES.ambarli,
    to: FERRIES.trieste,
    operator: TransitOperator.GRIMALDI_LINES,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 71 }).as('seconds'),
  },
  // Karasu
  {
    uuid: '986b7209-198b-4f70-b038-9fd346baafd1',
    type: OrderPointType.FERRY,
    from: FERRIES.karasu,
    to: FERRIES.constanta,
    operator: TransitOperator.SEA_CARGO,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 1 },
    duration: Duration.fromObject({ hours: 15 }).as('seconds'),
  },
  // Pendik
  {
    uuid: 'c74ee3a0-7159-4585-83b5-5459d5fa160a',
    type: OrderPointType.FERRY,
    from: FERRIES.pendik,
    to: FERRIES.bari,
    operator: TransitOperator.DFDS_SEAWAYS_MEDITERRANEAN,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 1 },
    duration: Duration.fromObject({ hours: 47 }).as('seconds'),
  },
  {
    uuid: '267cfad6-3127-4661-8ab4-e942a1dc229a',
    type: OrderPointType.FERRY,
    from: FERRIES.pendik,
    to: FERRIES.patras,
    operator: TransitOperator.DFDS_SEAWAYS_MEDITERRANEAN,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 2 },
    duration: Duration.fromObject({ hours: 32 }).as('seconds'),
  },
  {
    uuid: '9230a3b6-1ea1-4134-951f-9b98015a69a9',
    type: OrderPointType.FERRY,
    from: FERRIES.pendik,
    to: FERRIES.trieste,
    operator: TransitOperator.DFDS_SEAWAYS_MEDITERRANEAN,
    frequency: { interval: TransitFrequencyInterval.WEEK, value: 7 },
    duration: Duration.fromObject({ hours: 78 }).as('seconds'),
  },

  /* Wales */
  // Fishguard
  {
    uuid: 'f2fc376e-cb97-4bf6-98cf-fae545484830',
    type: OrderPointType.FERRY,
    from: FERRIES.fishguard,
    to: FERRIES.rosslare,
    operator: TransitOperator.STENA_LINE,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 4 }).as('seconds'),
  },
  // Holyhead
  {
    uuid: '0bcfdc7a-353d-4a2f-be6c-b7ab981225f1',
    type: OrderPointType.FERRY,
    from: FERRIES.holyhead,
    to: FERRIES.dublin,
    operator: TransitOperator.IRISH_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 4 },
    duration: Duration.fromObject({ hours: 4 }).as('seconds'),
  },
  // Pembroke
  {
    uuid: '14ef4193-d0ee-459f-9b28-47c04fde348e',
    type: OrderPointType.FERRY,
    from: FERRIES.pembroke,
    to: FERRIES.rosslare,
    operator: TransitOperator.IRISH_FERRIES,
    frequency: { interval: TransitFrequencyInterval.DAY, value: 2 },
    duration: Duration.fromObject({ hours: 4 }).as('seconds'),
  },
] as const;
